<template>
  <div>
    <a-modal
      v-model="visibleParentSuggestion"
      :footer="null"
      :mask="false"
      :height="500"
      :dialog-style="{
        top: '20px',
      }"
      :ok-button-props="{ props: { disabled: true } }"
      :cancel-button-props="{ props: { disabled: true } }"
    >
      <label class="typo__label">{{
        $t("profil.parentSuggestionTitle")
      }}</label>
      <multiselect
        v-model="selectedSuggestionParent"
        :placeholder="$t('recette.selectionnerParent')"
        :selectLabel="$t('sms.pressEnterToSelect')"
        :options="suggestionParentList"
        :custom-label="
          ({ name }) => {
            return name;
          }
        "
        :close-on-select="false"
        :preserve-search="true"
        :maxHeight="700"
        label="_id"
        track-by="_id"
        :preselect-first="true"
        :multiple="false"
      >
        <template slot="option" slot-scope="props">
          <div class="option__desc">
            <span class="align-text-top">
              {{ props.option.name }}
            </span>
            <br />
            <span class="align-text-top">
              {{ $t("profil.tel") }}: {{ props.option.fatherPhone }} -
              {{ props.option.motherPhone }}
            </span>
            <br />
            <span class="option__small font-size-12"
              >{{ $t("inscription.enfant") }} :
              {{ props.option.children }}</span
            >
          </div>
        </template>

        <template slot="noOptions">
          {{ $t("sms.noOptions") }}
        </template>
      </multiselect>
      <a-divider class="mt-3 mb-2"></a-divider>
      <div style="margin-bottom: 30px">
        <a-button
          @click="visibleParentSuggestion = false"
          class="ml-2 mr-2"
          style="float: right"
          >{{ $t("all.cancel") }}</a-button
        >
        <a-button
          @click="handleAddParentSuggestion"
          :disabled="!selectedSuggestionParent"
          type="primary"
          style="float: right"
          >{{ $t("all.add") }}</a-button
        >
      </div>
    </a-modal>
    <a-modal
      v-model="visibleDeleteReasson"
      v-show="visibleDeleteReasson"
      :title="$t('all.enterInformationBelow')"
      :width="500"
    >
      <div class="row">
        <div class="col-lg-12">
          <a-form-item :label="$t('punition.raison')">
            <a-input
              :placeholder="$t('punition.raison')"
              type="textarea"
              v-model="deleteReason"
            />
          </a-form-item>
        </div>
      </div>
      <template slot="footer">
        <a-button key="back" @click="visibleDeleteReasson = false">
          {{ $t("action.annuler") }}
        </a-button>
        <a-button key="submit" type="primary" @click="onDelete">
          {{ $t("all.okay") }}
        </a-button>
      </template>
    </a-modal>

    <a-page-header
      :title="$t('liste.listeEleves')"
      :sub-title="$t('liste.consulterProfil')"
    >
      <template slot="tags">
        <a-tag color="blue"> {{ $t("liste.administration") }} </a-tag>
      </template>
      <template slot="extra">
        <a-button type="primary" @click="showModal" key="add-student">
          <a-icon type="user-add" @click="showModal" />{{
            $t("liste.ajouterEleve")
          }}
        </a-button>
        <a-button type="primary" @click="showAddParentModal" key="add-parent">
          <a-icon type="usergroup-add" />{{ $t("liste.ajouterParent") }}
        </a-button>
        <a-button type="primary" @click="goToNewPayment" key="new-payment">
          <a-icon type="credit-card" @click="goToNewPayment" />{{
            $t("liste.nouveauPaiement")
          }}
        </a-button>
        <a-dropdown>
          <a-menu slot="overlay">
            <!-- Print & Export Section -->
            <a-menu-item-group :title="$t('menu.printExport')">
              <a-menu-item
                key="1"
                @click="generateBadges"
                :disabled="loadingBadges"
                :loading="loadingBadges"
                :class="{
                  disabledPack: !btnAccessGetter.includes('prBadge'),
                }"
              >
                <a-icon type="idcard" />
                {{ $t("action.imprimerBadges") }}
              </a-menu-item>
              <a-menu-item
                key="5"
                @click="generateNewBadges"
                :disabled="loadingBadges"
                :loading="loadingBadges"
                :class="{
                  disabledPack: !btnAccessGetter.includes('prBadgePhoto'),
                }"
              >
                <a-icon type="camera" />
                {{ $t("action.imprimerNewBadges") }}
              </a-menu-item>
              <a-menu-item
                key="2"
                @click="generatePdf"
                :class="{
                  disabledPack: !btnAccessGetter.includes('prStudentList'),
                }"
              >
                <a-icon type="file-pdf" />
                {{ $t("action.imprimerTab") }}
              </a-menu-item>
              <a-menu-item
                key="8"
                @click="generateSiblingsPdf"
                :disabled="loadingSiblingsPdf"
                :class="{
                  disabledPack: !btnAccessGetter.includes('prStudentList'),
                }"
              >
                <a-icon type="team" />
                {{ $t("action.imprimerFreresSoeurs") }}
              </a-menu-item>
            </a-menu-item-group>

            <!-- Access Management Section -->
            <a-menu-item-group :title="$t('menu.accessManagement')">
              <a-menu-item key="6" @click="showLevelsSelection">
                <a-icon
                  type="user"
                  :disabled="loadingLogins"
                  :loading="loadingLogins"
                />
                {{ $t('menu.parentLogins') }}
              </a-menu-item>
              <a-menu-item
                key="7"
                @click="showStudentLevelsSelection"
                :disabled="
                  loadingLogins ||
                  !btnAccessGetter.includes('printLoginsStudents')
                "
                :class="{
                  disabledPack: !btnAccessGetter.includes('printLoginsStudents'),
                }"
              >
                <a-icon type="team" :loading="loadingLogins" />
                {{ $t('menu.studentLogins') }}
              </a-menu-item>
            </a-menu-item-group>
            <!-- Data Management Section -->
            <a-menu-item-group :title="$t('menu.dataManagement')">
              <a-menu-item key="3" @click="openImport">
                <a-icon type="file-excel" />
                {{ $t("action.importer") }}
              </a-menu-item>
              <a-menu-item key="4" @click="openArchive">
                <a-icon type="inbox" />
                {{ $t("liste.listeElevesArchive") }}
              </a-menu-item>
            </a-menu-item-group>

          </a-menu>
          <a-button
            style="margin-left: 8px"
            :disabled="loadingLogins || loadingSiblingsPdf"
            :loading="loadingLogins || loadingSiblingsPdf"
          >
            {{ $t("action.actions") }} <a-icon type="down" />
          </a-button>
        </a-dropdown>
      </template>
      <a-descriptions size="small" :column="3">
        <a-descriptions-item :label="$t('liste.nonInscrits')">
          {{ stats.nonEnrolled }}
        </a-descriptions-item>
        <a-descriptions-item :label="$t('liste.inscrits')">
          {{ stats.enrolled }}
        </a-descriptions-item>
        <a-descriptions-item :label="$t('liste.parents')">
          {{ parentsCount }}
        </a-descriptions-item>
      </a-descriptions>
      <a-row type="flex">
        <a-statistic :title="$t('liste.total')" :value="pagination.total" />
        <a-statistic
          :title="$t('profil.fille')"
          prefix="%"
          :value="countFille"
          :style="{
            margin: '0 32px',
          }"
        />
        <a-statistic
          :title="$t('profil.garcon')"
          prefix="%"
          :value="countGarcon"
        />
      </a-row>
    </a-page-header>
    <div>
      <a-modal
        v-model="visibleData"
        v-show="visibleData"
        :title="$t('all.enterInformationBelow')"
        on-ok="addStudent"
        :width="1000"
      >
        <template slot="footer">
          <a-button
            key="back"
            :disabled="loadingData"
            @click="handleCancelModalAdd"
          >
            {{ $t("action.annuler") }}
          </a-button>
          <a-button
            key="submit"
            type="primary"
            :disabled="loadingData"
            @click="addStudent"
          >
            {{ $t("action.confirmer") }}
          </a-button>
        </template>
        <a-form :form="newStudentForm" class="container" @submit="addStudent">
          <div class="row">
            <div class="col-lg-4" v-if="isKenyanSchool()">
              <a-form-item :label="$t('profil.nemisNumber')">
                <a-input
                  @change="debounceField"
                  :placeholder="$t('profil.nemisNumber')"
                  v-decorator="[
                    'nemisNumber',
                    {
                      trigger: ``,
                    },
                  ]"
                />
              </a-form-item>
            </div>
            <div class="col-lg-4" v-else>
              <a-form-item :label="$t('liste.identifiantUnique')">
                <a-input
                  @change="debounceField"
                  :placeholder="
                    $t('liste.identifiantUnique') + ' (المعرف الوحيد)'
                  "
                  v-decorator="[
                    'uniqueId',
                    {
                      trigger: ``,
                    },
                  ]"
                />
              </a-form-item>
            </div>
            <div class="col-lg-4">
              <a-form-item :label="$t('profil.prenom')">
                <a-input
                  @change="debounceField"
                  :placeholder="$t('profil.prenom')"
                  v-decorator="[
                    'firstName',
                    {
                      trigger: ``,
                      rules: [
                        {
                          required: true,
                          message: $t('requis.prenomPere'),
                        },
                      ],
                    },
                  ]"
                />
              </a-form-item>
            </div>
            <div class="col-lg-4">
              <a-form-item :label="$t('profil.nom')">
                <a-input
                  @change="debounceField"
                  :placeholder="$t('profil.nom')"
                  v-decorator="[
                    'lastName',
                    {
                      trigger: ``,
                      rules: [
                        {
                          required: true,
                          message: $t('requis.nom'),
                        },
                      ],
                    },
                  ]"
                />
              </a-form-item>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-4">
              <a-form-item :label="$t('profil.middleName')">
                <a-input
                  @change="debounceField"
                  :placeholder="$t('profil.middleName')"
                  v-decorator="[
                    'middleName',
                    {
                      trigger: ``,
                      rules: [
                        {
                          required: false,
                        },
                      ],
                    },
                  ]"
                />
              </a-form-item>
            </div>
            <div class="col-lg-4">
              <a-form-item :label="$t('profil.dateNaissance')">
                <a-date-picker
                  style="width: 100%"
                  :placeholder="$t('profil.dateNaissance')"
                  format="DD/MM/YYYY"
                  :disabled-date="disabledDate"
                  v-decorator="[
                    'BirthDate',
                    {
                      rules: [
                        {
                          required: true,
                          message: $t('requis.dateNaissance'),
                        },
                      ],
                    },
                  ]"
                />
              </a-form-item>
            </div>
            <div class="col-lg-4">
              <a-form-item :label="$t('profil.sexe')">
                <a-radio-group
                  :placeholder="$t('profil.sexe')"
                  v-decorator="[
                    'gender',
                    {
                      rules: [
                        {
                          required: true,
                          message: $t('requis.genre'),
                        },
                      ],
                    },
                  ]"
                >
                  <a-radio value="male"> {{ $t("profil.garcon") }}</a-radio>
                  <a-radio value="female"> {{ $t("profil.fille") }} </a-radio>
                </a-radio-group>
              </a-form-item>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6">
              <a-form-item :label="$t('profil.adresse')">
                <a-input
                  :placeholder="$t('profil.adresse')"
                  @change="debounceField"
                  v-decorator="['adress', { trigger: `` }]"
                />
              </a-form-item>
            </div>
            <div class="col-lg-6">
              <a-form-item :label="$t('liste.telephone')">
                <phone-number-input
                :default-country-code="isKenyanSchool() ? 'KE' : 'TN'"
                @raw-change="handlePhoneChange"
                :placeholder="$t('liste.telephone')"
                v-decorator="[
                  'phone',
                  {
                    trigger: ``,
                    rules: [],
                  },
                ]"
                />
              </a-form-item>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6">
              <a-form-item :label="$t('profil.postalAddress')">
                <a-input
                  :placeholder="$t('profil.postalAddress')"
                  @change="debounceField"
                  v-decorator="['postalAddress', { trigger: `` }]"
                />
              </a-form-item>
            </div>
            <div class="col-lg-6">
              <a-form-item :label="$t('profil.physicalAddress')">
                <a-input
                  :placeholder="$t('profil.physicalAddress')"
                  @change="debounceField"
                  v-decorator="['physicalAddress', { trigger: `` }]"
                />
              </a-form-item>
            </div>
          </div>
          <template v-if="isKenyanSchool()">
            <div class="row">
              <div class="col-lg-6">
                <a-form-item :label="$t('profil.birthCertificate')">
                  <a-upload
                    :before-upload="beforeUploadBirthCertificate"
                    :file-list="birthCertificateFileList"
                    :customRequest="addToBirthCertificateList"
                    @change="handleChangeBirthCertificate"
                    v-decorator="[
                      'birthCertificate',
                      {
                        trigger: ``,
                        rules: [
                          {
                            required: shouldRequireBirthCertificate,
                            message: $t('requis.birthCertificate'),
                          },
                        ],
                      },
                    ]"
                  >
                    <a-button style="width: 100%; display: block">
                      <a-icon type="upload" /> {{ $t('recette.uploadFile') }}
                    </a-button>
                  </a-upload>
                </a-form-item>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6">
                <a-form-item :label="$t('profil.saccoName') ">
                  <a-input
                    @change="debounceField"
                    :placeholder="$t('profil.saccoName') "
                    v-decorator="[
                      'saccoName',
                      {
                        trigger: ``,
                        rules: [
                          {
                            required: false,
                          },
                        ],
                      },
                    ]"
                  />
                </a-form-item>
              </div>
              <div class="col-lg-6">
                <a-form-item :label="$t('profil.saccoBankName')">
                  <a-input
                    @change="debounceField"
                    :placeholder="$t('profil.saccoBankName') "
                    v-decorator="[
                      'saccoBankName',
                      {
                        trigger: ``,
                        rules: [
                          {
                            required: false,
                          },
                        ],
                      },
                    ]"
                  />
                </a-form-item>
              </div>
            </div>
          </template>
          <div class="row">
            <div class="col-lg-12">
              <a-form-item :label="$t('profil.notes')">
                <a-input
                  :placeholder="$t('profil.notes')"
                  type="textarea"
                  @change="debounceField"
                  v-decorator="[
                    'notes',
                    {
                      trigger: ``,
                    },
                  ]"
                />
              </a-form-item>
            </div>
          </div>
          <a-divider>{{ $t('profil.healthInformation') }}</a-divider>
          <div class="row">
            <div class="col-lg-6">
              <a-form-item :label="$t('profil.bloodType')">
                <a-select
                  :placeholder="$t('profil.bloodType')"
                  allowClear
                  v-decorator="[
                    'healthInfo.bloodType',
                    {
                      trigger: 'change',
                      rules: [
                        {
                          required: false,
                        },
                      ],
                    },
                  ]"
                >
                  <a-select-option key="A+" value="A+">A+</a-select-option>
                  <a-select-option key="A-" value="A-">A-</a-select-option>
                  <a-select-option key="B+" value="B+">B+</a-select-option>
                  <a-select-option key="B-" value="B-">B-</a-select-option>
                  <a-select-option key="AB+" value="AB+">AB+</a-select-option>
                  <a-select-option key="AB-" value="AB-">AB-</a-select-option>
                  <a-select-option key="O+" value="O+">O+</a-select-option>
                  <a-select-option key="O-" value="O-">O-</a-select-option>
                  <a-select-option key="Unknown" value="Unknown">{{ $t('profil.unknown') }}</a-select-option>
                </a-select>
              </a-form-item>
            </div>
            <div class="col-lg-6">
              <a-form-item :label="$t('profil.medicalCondition')">
                <a-input
                  :placeholder="$t('profil.medicalCondition')"
                  @change="debounceField"
                  v-decorator="[
                    'healthInfo.medicalCondition',
                    {
                      trigger: ``,
                      rules: [
                        {
                          required: false,
                        },
                      ],
                    },
                  ]"
                />
              </a-form-item>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12">
              <a-form-item :label="$t('profil.medicalNotes')">
                <a-input
                  :placeholder="$t('profil.medicalNotes')"
                  type="textarea"
                  @change="debounceField"
                  v-decorator="[
                    'medicalNotes',
                    {
                      trigger: ``,
                      rules: [
                        {
                          required: false,
                        },
                      ],
                    },
                  ]"
                />
              </a-form-item>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6">
              <a-form-item :label="$t('profil.allergies')">
                <a-input
                  :placeholder="$t('profil.allergies')"
                  @change="debounceField"
                  v-decorator="[
                    'healthInfo.allergies',
                    {
                      trigger: ``,
                      rules: [
                        {
                          required: false,
                        },
                      ],
                    },
                  ]"
                />
              </a-form-item>
            </div>
            <div class="col-lg-6">
              <a-form-item :label="$t('profil.parentNoteOnAllergies')">
                <a-input
                  :placeholder="$t('profil.parentNoteOnAllergies')"
                  type="textarea"
                  @change="debounceField"
                  v-decorator="[
                    'healthInfo.parentNoteOnAllergies',
                    {
                      trigger: ``,
                      rules: [
                        {
                          required: false,
                        },
                      ],
                    },
                  ]"
                />
              </a-form-item>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <a-form-item :label="$t('liste.classes')">
                <a-select
                  show-search
                  :placeholder="$t('liste.classes')"
                  option-filter-prop="children"
                  :filter-option="filterOption"
                  @change="
                    (val) => {
                      selectedClassRoom = classRoomList.find(
                        (item) => item.id === val
                      );
                    }
                  "
                  v-decorator="[
                    'classRoom',
                    {
                      rules: [
                        {
                          required: false,
                        },
                      ],
                    },
                  ]"
                >
                  >
                  <a-select-option
                    :value="item.id"
                    v-for="item in classRoomList"
                    :key="item.id"
                  >
                    {{ item.name }}
                    <a-tag
                      v-if="item.classroomType === 'affectation'"
                      color="orange"
                      class="ml-2"
                    >
                      {{ $t("etablissement.niveauAffectation") }}
                    </a-tag>
                  </a-select-option>
                </a-select>
              </a-form-item>
            </div>
            <div class="col-md-8 mt-4">
              <a-tag color="green" class="mb-1 mt-4">
                {{ $t("inscription.fraisInscri") }} :
                {{
                  selectedClassRoom ? selectedClassRoom.inscription : "--"
                }}</a-tag
              >
              <a-tag color="green" class="mb-1 mt-4">
                {{ $t("inscription.fraisMensuel") }} :
                {{
                  selectedClassRoom ? selectedClassRoom.monthly : "--"
                }}</a-tag
              >
            </div>
          </div>

          <div class="row" v-if="selectedClassRoom">
            <div class="col-lg-3">
              <h6 for="">{{ $t("inscription.fraisInscri") + " (dt)" }}</h6>
              <p>{{ selectedClassRoom.inscription }}</p>
            </div>
            <div
              @click="changeModeP('M')"
              :class="[
                'col-lg-4',
                'mr-2',
                'pt-2',
                modePaiement === 'M' ? 'custom-border-active' : 'custom-border',
              ]"
            >
              <h6 for="">{{ $t("inscription.fraisMensuel") + " (dt)" }}</h6>
              <p>{{ selectedClassRoom.monthly }}</p>
            </div>
            <div
              @click="changeModeP('T')"
              :class="[
                'col-lg-4',
                'pt-2',
                modePaiement === 'T' ? 'custom-border-active' : 'custom-border',
              ]"
              v-if="selectedClassRoom.tranches"
            >
              <h6 for="">{{ $t("liste.fraisTranches") + " (dt)" }}</h6>
              <li
                v-for="t in selectedClassRoom.tranches"
                :key="t.trancheNumber"
              >
                {{ "Tranche " + t.trancheNumber + " : " + t.amount }}
              </li>
            </div>
            <a-alert
              class="mt-2"
              :message="
                $t('liste.paymentMode') +
                (modePaiement === 'T'
                  ? $t('liste.tranches')
                  : $t('liste.mensuelle'))
              "
              type="info"
              show-icon
            />
            <a-divider />
          </div>

          <div class="row">
            <div class="col-md-5">
              <a-form-item :label="$t('liste.parentsExis')">
                <a-select
                  :disabled="disabledSP"
                  show-search
                  :autoFocus="true"
                  :placeholder="$t('liste.parentsExis')"
                  option-filter-prop="children"
                  :filter-option="filterOption"
                  v-decorator="[
                    'parent',
                    {
                      rules: [
                        {
                          required: !newParent,
                          message: $t('requis.selection'),
                        },
                      ],
                    },
                  ]"
                >
                  <a-select-option
                    :value="item.id"
                    v-for="item in parentsList"
                    :key="item.id"
                  >
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </div>
            <div class="col-md-3">
              <a-form-item :label="$t('liste.ajouterParent')">
                <a-switch @change="triggerAddNewParent" v-model="newParent">
                  <a-icon slot="checkedChildren" type="usergroup-add" />
                  <a-icon slot="unCheckedChildren" type="close" />
                </a-switch>
              </a-form-item>
            </div>
          </div>
          <a-card
            :title="$t('liste.ficheParents')"
            :bordered="true"
            class="span container"
            v-if="newParent"
          >
            <div class="row">
              <div class="col-lg-6">
                <a-form-item :label="$t('liste.nomPere')">
                  <a-input
                    :placeholder="$t('liste.nomPere')"
                    @change="debounceField"
                    type="text"
                    v-decorator="[
                      'parentdata.father.firstName',
                      {
                        trigger: ``,
                        rules: [
                          {
                            required: true,
                            message: $t('requis.nomPere'),
                          },
                        ],
                      },
                    ]"
                  />
                </a-form-item>
              </div>
              <div class="col-lg-6">
                <a-form-item :label="$t('liste.prenomPere')">
                  <a-input
                    @change="debounceField"
                    :placeholder="$t('liste.prenomPere')"
                    type="text"
                    v-decorator="[
                      'parentdata.father.lastName',
                      {
                        trigger: ``,
                        rules: [
                          {
                            required: true,
                            message: $t('requis.prenomPere'),
                          },
                        ],
                      },
                    ]"
                  />
                </a-form-item>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6">
                <a-form-item :label="$t('liste.nomMere')">
                  <a-input
                    @change="debounceField"
                    :placeholder="$t('liste.nomMere')"
                    type="text"
                    v-decorator="[
                      'parentdata.mother.firstName',
                      {
                        trigger: ``,
                        rules: [
                          {
                            required: true,
                            message: $t('requis.nomMere'),
                          },
                        ],
                      },
                    ]"
                  />
                </a-form-item>
              </div>
              <div class="col-lg-6">
                <a-form-item :label="$t('liste.prenomMere')">
                  <a-input
                    @change="debounceField"
                    :placeholder="$t('liste.prenomMere')"
                    type="text"
                    v-decorator="[
                      'parentdata.mother.lastName',
                      {
                        trigger: ``,
                        rules: [
                          {
                            required: true,
                            message: $t('requis.prenomMere'),
                          },
                        ],
                      },
                    ]"
                  />
                </a-form-item>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6">
                <a-form-item
                  :label="
                    $t('profil.middleName') + ' (' + $t('profil.father') + ')'
                  "
                >
                  <a-input
                    @change="debounceField"
                    :placeholder="$t('profil.middleName')"
                    type="text"
                    v-decorator="[
                      'parentdata.father.middleName',
                      {
                        trigger: ``,
                      },
                    ]"
                  />
                </a-form-item>
              </div>
              <div class="col-lg-6">
                <a-form-item
                  :label="
                    $t('profil.middleName') + ' (' + $t('profil.mother') + ')'
                  "
                >
                  <a-input
                    @change="debounceField"
                    :placeholder="$t('profil.middleName')"
                    type="text"
                    v-decorator="[
                      'parentdata.mother.middleName',
                      {
                        trigger: ``,
                      },
                    ]"
                  />
                </a-form-item>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6">
                <a-form-item :label="$t('liste.telPere')">
                  <phone-number-input
                    :default-country-code="isKenyanSchool() ? 'KE' : 'TN'"
                    @raw-change="handleFatherPhoneChange"
                    :placeholder="$t('liste.telPere')"
                    v-decorator="[
                      'parentdata.father.phone',
                      {
                        trigger: ``,
                        rules: [
                          {
                            required: true,
                            message: $t('requis.telPere'),
                          },
                        ],
                      },
                    ]"
                  />
                </a-form-item>
              </div>
              <div class="col-lg-6">
                <a-form-item :label="$t('liste.telMere')">
                  <phone-number-input
                    :default-country-code="isKenyanSchool() ? 'KE' : 'TN'"
                    @raw-change="handleMotherPhoneChange"
                    :placeholder="$t('liste.telMere')"
                    v-decorator="[
                      'parentdata.mother.phone',
                      {
                        trigger: ``,
                        rules: [
                          {
                            required: true,
                            message: $t('requis.telMere'),
                          },
                        ],
                      },
                    ]"
                  />
                </a-form-item>
              </div>
            </div>
            <!--parents job-->
            <div class="row">
              <div class="col-lg-6">
                <a-form-item :label="$t('liste.metierPere')">
                  <a-input
                    :placeholder="$t('liste.metierPere')"
                    @change="debounceField"
                    v-decorator="[
                      'parentdata.father.job',
                      {
                        trigger: ``,
                      },
                    ]"
                  />
                </a-form-item>
              </div>
              <div class="col-lg-6">
                <a-form-item :label="$t('liste.metierMere')">
                  <a-input
                    @change="debounceField"
                    :placeholder="$t('liste.metierMere')"
                    v-decorator="[
                      'parentdata.mother.job',
                      {
                        trigger: ``,
                      },
                    ]"
                  />
                </a-form-item>
              </div>
            </div>
            <!-- National ID (CIN) -->
            <div class="row">
              <div class="col-lg-6">
                <a-form-item :label="$t('liste.cinPere')">
                  <a-input
                    :placeholder="$t('liste.cinPere')"
                    maxlength="8"
                    @change="debounceField"
                    v-decorator="[
                      'parentdata.father.cin',
                      {
                        trigger: ``,
                        rules: [
                          {
                            validator: (rule, value, cb) => {
                              if (!value || String(value).trim() === '') return cb();
                              if (!/^[01]\d{7}$/.test(String(value).trim())) return cb(this.$t('requis.cin01'));
                              cb();
                            },
                          },
                        ],
                      },
                    ]"
                  />
                </a-form-item>
              </div>
              <div class="col-lg-6">
                <a-form-item :label="$t('liste.cinMere')">
                  <a-input
                    :placeholder="$t('liste.cinMere')"
                    maxlength="8"
                    @change="debounceField"
                    v-decorator="[
                      'parentdata.mother.cin',
                      {
                        trigger: ``,
                        rules: [
                          {
                            validator: (rule, value, cb) => {
                              if (!value || String(value).trim() === '') return cb();
                              if (!/^[01]\d{7}$/.test(String(value).trim())) return cb(this.$t('requis.cin01'));
                              cb();
                            },
                          },
                        ],
                      },
                    ]"
                  />
                </a-form-item>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6">
                <a-form-item :label="$t('liste.emailPere')">
                  <a-input
                    :placeholder="$t('liste.emailPere')"
                    type="text"
                    @change="debounceField"
                    v-decorator="[
                      'parentdata.father.email',
                      {
                        trigger: ``,
                        rules: [
                          {
                            required: false,
                            type: 'email',
                            message: $t('requis.email'),
                          },
                        ],
                      },
                    ]"
                  />
                </a-form-item>
              </div>
              <div class="col-lg-6">
                <a-form-item :label="$t('liste.emailMere')">
                  <a-input
                    :placeholder="$t('liste.emailMere')"
                    type="text"
                    @change="debounceField"
                    v-decorator="[
                      'parentdata.mother.email',
                      {
                        trigger: ``,
                        rules: [
                          {
                            required: false,
                            type: 'email',
                            message: $t('requis.email'),
                          },
                        ],
                      },
                    ]"
                  />
                </a-form-item>
              </div>
              <div class="col-lg-6">
                <a-form-item :label="$t('liste.adressePere')">
                  <a-input
                    :placeholder="$t('liste.adressePere')"
                    type="text"
                    @change="debounceField"
                    v-decorator="[
                      'parentdata.father.adress',
                      {
                        trigger: ``,
                      },
                    ]"
                  />
                </a-form-item>
              </div>
              <div class="col-lg-6">
                <a-form-item :label="$t('liste.adresseMere')">
                  <a-input
                    :placeholder="$t('liste.adresseMere')"
                    type="text"
                    @change="debounceField"
                    v-decorator="[
                      'parentdata.mother.adress',
                      {
                        trigger: ``,
                      },
                    ]"
                  />
                </a-form-item>
              </div>
            </div>
          </a-card>
        </a-form>
      </a-modal>

      <a-modal
        v-model="addNewParent"
        v-show="addNewParent"
        :title="$t('liste.ajouterParent')"
        :width="1000"
        :destroyOnClose="true"
      >
        <template slot="footer">
          <a-button
            key="back"
            :disabled="loadingAddParent"
            @click="handleCancelAddParent"
          >
            {{ $t("action.annuler") }}
          </a-button>
          <a-button
            key="submit"
            type="primary"
            :loading="loadingAddParent"
            :disabled="loadingAddParent"
            @click="addParentOnly"
          >
            {{ $t("action.confirmer") }}
          </a-button>
        </template>
        <a-form :form="newParentOnlyForm" class="container" @submit="addParentOnly">
          <a-alert
            class="mb-3"
            type="info"
            show-icon
            :message="$t('liste.ajouterParentSansEleveHint')"
          />
          <a-card
            :title="$t('liste.ficheParents')"
            :bordered="true"
            class="span container"
          >
            <div class="row">
              <div class="col-lg-6">
                <a-form-item :label="$t('liste.nomPere')">
                  <a-input
                    :placeholder="$t('liste.nomPere')"
                    type="text"
                    v-decorator="[
                      'father.firstName',
                      {
                        rules: [
                          {
                            required: true,
                            message: $t('requis.nomPere'),
                          },
                        ],
                      },
                    ]"
                  />
                </a-form-item>
              </div>
              <div class="col-lg-6">
                <a-form-item :label="$t('liste.prenomPere')">
                  <a-input
                    :placeholder="$t('liste.prenomPere')"
                    type="text"
                    v-decorator="[
                      'father.lastName',
                      {
                        rules: [
                          {
                            required: true,
                            message: $t('requis.prenomPere'),
                          },
                        ],
                      },
                    ]"
                  />
                </a-form-item>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6">
                <a-form-item :label="$t('liste.nomMere')">
                  <a-input
                    :placeholder="$t('liste.nomMere')"
                    type="text"
                    v-decorator="[
                      'mother.firstName',
                      {
                        rules: [
                          {
                            required: true,
                            message: $t('requis.nomMere'),
                          },
                        ],
                      },
                    ]"
                  />
                </a-form-item>
              </div>
              <div class="col-lg-6">
                <a-form-item :label="$t('liste.prenomMere')">
                  <a-input
                    :placeholder="$t('liste.prenomMere')"
                    type="text"
                    v-decorator="[
                      'mother.lastName',
                      {
                        rules: [
                          {
                            required: true,
                            message: $t('requis.prenomMere'),
                          },
                        ],
                      },
                    ]"
                  />
                </a-form-item>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6">
                <a-form-item
                  :label="
                    $t('profil.middleName') + ' (' + $t('profil.father') + ')'
                  "
                >
                  <a-input
                    :placeholder="$t('profil.middleName')"
                    type="text"
                    v-decorator="['father.middleName']"
                  />
                </a-form-item>
              </div>
              <div class="col-lg-6">
                <a-form-item
                  :label="
                    $t('profil.middleName') + ' (' + $t('profil.mother') + ')'
                  "
                >
                  <a-input
                    :placeholder="$t('profil.middleName')"
                    type="text"
                    v-decorator="['mother.middleName']"
                  />
                </a-form-item>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6">
                <a-form-item :label="$t('liste.telPere')">
                  <phone-number-input
                    :default-country-code="isKenyanSchool() ? 'KE' : 'TN'"
                    @raw-change="handleNewParentFatherPhoneChange"
                    :placeholder="$t('liste.telPere')"
                    v-decorator="[
                      'father.phone',
                      {
                        trigger: ``,
                        rules: [
                          {
                            required: true,
                            message: $t('requis.telPere'),
                          },
                        ],
                      },
                    ]"
                  />
                </a-form-item>
              </div>
              <div class="col-lg-6">
                <a-form-item :label="$t('liste.telMere')">
                  <phone-number-input
                    :default-country-code="isKenyanSchool() ? 'KE' : 'TN'"
                    @raw-change="handleNewParentMotherPhoneChange"
                    :placeholder="$t('liste.telMere')"
                    v-decorator="[
                      'mother.phone',
                      {
                        trigger: ``,
                        rules: [
                          {
                            required: true,
                            message: $t('requis.telMere'),
                          },
                        ],
                      },
                    ]"
                  />
                </a-form-item>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6">
                <a-form-item :label="$t('liste.metierPere')">
                  <a-input
                    :placeholder="$t('liste.metierPere')"
                    v-decorator="['father.job']"
                  />
                </a-form-item>
              </div>
              <div class="col-lg-6">
                <a-form-item :label="$t('liste.metierMere')">
                  <a-input
                    :placeholder="$t('liste.metierMere')"
                    v-decorator="['mother.job']"
                  />
                </a-form-item>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6">
                <a-form-item :label="$t('liste.cinPere')">
                  <a-input
                    :placeholder="$t('liste.cinPere')"
                    maxlength="8"
                    v-decorator="[
                      'father.cin',
                      {
                        rules: [
                          {
                            validator: (rule, value, cb) => {
                              if (!value || String(value).trim() === '') return cb();
                              if (!/^[01]\d{7}$/.test(String(value).trim())) return cb(this.$t('requis.cin01'));
                              cb();
                            },
                          },
                        ],
                      },
                    ]"
                  />
                </a-form-item>
              </div>
              <div class="col-lg-6">
                <a-form-item :label="$t('liste.cinMere')">
                  <a-input
                    :placeholder="$t('liste.cinMere')"
                    maxlength="8"
                    v-decorator="[
                      'mother.cin',
                      {
                        rules: [
                          {
                            validator: (rule, value, cb) => {
                              if (!value || String(value).trim() === '') return cb();
                              if (!/^[01]\d{7}$/.test(String(value).trim())) return cb(this.$t('requis.cin01'));
                              cb();
                            },
                          },
                        ],
                      },
                    ]"
                  />
                </a-form-item>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6">
                <a-form-item :label="$t('liste.emailPere')">
                  <a-input
                    :placeholder="$t('liste.emailPere')"
                    type="text"
                    v-decorator="[
                      'father.email',
                      {
                        rules: [
                          {
                            required: false,
                            type: 'email',
                            message: $t('requis.email'),
                          },
                        ],
                      },
                    ]"
                  />
                </a-form-item>
              </div>
              <div class="col-lg-6">
                <a-form-item :label="$t('liste.emailMere')">
                  <a-input
                    :placeholder="$t('liste.emailMere')"
                    type="text"
                    v-decorator="[
                      'mother.email',
                      {
                        rules: [
                          {
                            required: false,
                            type: 'email',
                            message: $t('requis.email'),
                          },
                        ],
                      },
                    ]"
                  />
                </a-form-item>
              </div>
              <div class="col-lg-6">
                <a-form-item :label="$t('liste.adressePere')">
                  <a-input
                    :placeholder="$t('liste.adressePere')"
                    type="text"
                    v-decorator="['father.adress']"
                  />
                </a-form-item>
              </div>
              <div class="col-lg-6">
                <a-form-item :label="$t('liste.adresseMere')">
                  <a-input
                    :placeholder="$t('liste.adresseMere')"
                    type="text"
                    v-decorator="['mother.adress']"
                  />
                </a-form-item>
              </div>
            </div>
          </a-card>
        </a-form>
      </a-modal>
    </div>
    <div>
      <div
        class="mb-2"
        style="
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          gap: 12px 16px;
        "
      >
        <div style="display: inline-flex; align-items: center; flex-wrap: wrap">
          <a-input-search
            class="w-25"
            style="min-width: 220px; max-width: 320px"
            :placeholder="$t('liste.searchStudent')"
            @search="onSearch"
          />
          <a-popover :title="$t('liste.searchBy')">
            <template slot="content">
              <ul>
                <li>{{ $t("paiement.nom") }}</li>
                <li>{{ $t("paiement.prenom") }}</li>
                <li>{{ $t("profil.nomFr") }}</li>
                <li>{{ $t("profil.prenomFr") }}</li>
                <li>{{ $t("profil.middleNameFr") }}</li>
                <li>{{ $t("liste.scolarite") }}</li>
                <li>{{ $t("liste.nomPere") }}</li>
                <li>{{ $t("liste.prenomPere") }}</li>
                <li>{{ $t("liste.telPere") }}</li>
                <li>{{ $t("liste.nomMere") }}</li>
                <li>{{ $t("liste.prenomMere") }}</li>
                <li>{{ $t("liste.telMere") }}</li>
              </ul>
            </template>
            <a-icon
              type="info-circle"
              :style="{ fontSize: '18px', color: '#9b9b9b', cursor: 'pointer' }"
              class="ml-2"
            />
          </a-popover>
        </div>
        <div
          v-if="isKenyanSchool()"
          style="display: inline-flex; align-items: center; flex-wrap: wrap"
        >
          <span
            class="text-secondary"
            style="font-size: 13px; white-space: nowrap; margin-right: 4px"
            >{{ $t("liste.photoMediaConsentFilterLabel") }}</span
          >
          <a-select
            v-model="photoMediaConsentFilter"
            style="min-width: 200px"
            @change="onPhotoMediaConsentFilterChange"
          >
            <a-select-option value="all">{{
              $t("liste.photoMediaConsentAll")
            }}</a-select-option>
            <a-select-option value="accepted">{{
              $t("liste.photoMediaConsentAccepted")
            }}</a-select-option>
            <a-select-option value="refused">{{
              $t("liste.photoMediaConsentRefused")
            }}</a-select-option>
            <a-select-option value="pending">{{
              $t("liste.photoMediaConsentPending")
            }}</a-select-option>
          </a-select>
        </div>
      </div>
      <a-table
        @change="tableChanged"
        :loading="tableLeading"
        :pagination="pagination"
        :data-source="data"
        :columns="columns"
        :rowKey="'_id'"
      >
        <template slot="firstName" slot-scope="text, record">
          <div key="firstName" @click="() => openProfile(record.id)">
            <a-input
              v-if="record.editable"
              style="margin: -5px 0"
              :value="text"
              @change="(e) => handleChange(e.target.value, record.id, col)"
            />
            <template v-else>
              <a-avatar
                size="large"
                v-if="record.photo"
                :src="settings.resourcesUrl.replace('FILE_PATH', record.photo)"
              />
              <a-avatar
                size="large"
                style="color: #f56a00; background-color: #fde3cf"
                v-else
              >
                {{ record.firstName[0].toUpperCase() }}
              </a-avatar>
              <a-button size="small" type="link" class="ml-2">
                {{ text + (record.middleName ? " " + record.middleName : "") + " " + record.lastName }}
              </a-button>
            </template>
          </div>
        </template>
        <span slot="scolarite" slot-scope="text, record">
          <a-tag
            :color="
              text === 'NON INSCRIT' || text === 'غير مسجل'
                ? 'volcano'
                : 'green'
            "
          >
            {{
              typeof text === "string" ? text.toUpperCase() : text
            }}
          </a-tag>
          <a-tag
            v-if="record.classroomType === 'affectation'"
            color="orange"
            class="ml-1"
          >
            {{ $t("etablissement.niveauAffectation") }}
          </a-tag>
        </span>
        <span slot="photoMediaConsent" slot-scope="text, record">
          <a-tag v-if="record.parentPhotoMediaConsent === true" color="green">{{
            $t("liste.photoMediaConsentAccepted")
          }}</a-tag>
          <a-tag
            v-else-if="record.parentPhotoMediaConsent === false"
            color="red"
            >{{ $t("liste.photoMediaConsentRefused") }}</a-tag
          >
          <a-tag v-else color="orange">{{
            $t("liste.photoMediaConsentPending")
          }}</a-tag>
        </span>
        <a-button
          slot="attestationPresence"
          slot-scope="text, record"
          :disabled="
            record.scolarite === 'NON INSCRIT' ||
            record.scolarite === 'غير مسجل' ||
            !countryIsTN
          "
          @click="
            () => {
              attestationPresence(record);
            }
          "
        >
          <a-icon type="file-pdf" /> {{ $t("action.imprimer") }}
        </a-button>
        <a-button
          slot="inscription"
          slot-scope="text, record"
          @click="() => attestationInscription(record)"
        >
          <a-icon type="file-pdf" /> {{ $t("action.imprimer") }}
        </a-button>

        <!-- <template slot="payment" slot-scope="text, record">
           <MultiPaymentValidater
            :idParent="record.parent[0]._id"
            :student="record"
            @reload="reload"
            :classroomName="record.scolarite ? record.scolarite : ''"
          />
        </template>-->
        <template slot="delete" slot-scope="text, record">
          <a-button-group>
            <a-popconfirm
              :title="$t('requis.supp2')"
              @confirm="() => deleteStudent(record.id)"
              v-if="verifyAccess(['all', 'suppression_eleve'])"
            >
              <a-button type="danger" size="small" icon="delete">
                {{ $t("action.supprimer") }}
              </a-button>
            </a-popconfirm>
            <a-button
              v-else
              type="danger"
              :disabled="true"
              size="small"
              icon="delete"
            >
              {{ $t("action.supprimer") }}
            </a-button>
            <a-popconfirm
              :title="$t('requis.annu')"
              @confirm="() => onCancelInscription(record.id)"
              v-if="
                verifyAccess(['all', 'annulation_eleve']) &&
                record.scolarite.toLowerCase() !== 'non inscrit'
              "
            >
              <a-button type="danger" size="small" icon="user-delete">
                {{ $t("action.annuler") }}
              </a-button>
            </a-popconfirm>
            <a-button
              v-else
              type="danger"
              size="small"
              icon="user-delete"
              :disabled="true"
            >
              {{ $t("action.annuler") }}
            </a-button>
          </a-button-group>
        </template>
      </a-table>
    </div>
    <a-modal
      v-model="visibleParentFile"
      :title="$t('all.enterInformationBelow')"
      width="50%"
      :key="'parentFile-' + componentKey"
      centered
    >
      <template slot="footer">
        <a-button key="back" @click="handleCancelModalParent">
          {{ $t("action.annuler") }}
        </a-button>
        <a-button
          key="submit"
          type="primary"
          :loading="loadingData"
          :disabled="loadingData"
          @click="updateParent"
        >
          {{ $t("action.confirmer") }}
        </a-button>
      </template>
      <div class="container">
        <span class="span row">
          <label class="col-md-6">
            {{ $t("liste.nomPere") }}
            <a-input
              id="nomPere"
              type="text"
              name="nomPere"
              :default-value="activeParent.father.firstName"
            />
          </label>
          <label class="col-md-6">
            {{ $t("liste.prenomPere") }}
            <a-input
              id="prenomPere"
              type="text"
              name="prenomPere"
              :default-value="activeParent.father.lastName"
            />
          </label>
        </span>
        <span class="span row">
          <label class="col-md-6">
            {{ $t("profil.middleName") }} ({{ $t("profil.father") }})
            <a-input
              id="middleNamePere"
              type="text"
              name="middleNamePere"
              :default-value="
                (activeParent.father && activeParent.father.middleName) || ''
              "
            />
          </label>
        </span>
        <span class="span row">
          <label class="col-md-6">
            {{ $t("liste.nomMere") }}
            <a-input
              id="nomMere"
              class="inp"
              type="text"
              name="nomMere"
              :default-value="activeParent.mother.firstName"
            />
          </label>
          <label class="col-md-6">
            {{ $t("liste.prenomMere") }}
            <a-input
              id="prenomMere"
              class="inp"
              type="text"
              name="prenomMere"
              :default-value="activeParent.mother.lastName"
            />
          </label>
        </span>
        <span class="span row">
          <label class="col-md-6">
            {{ $t("profil.middleName") }} ({{ $t("profil.mother") }})
            <a-input
              id="middleNameMere"
              type="text"
              name="middleNameMere"
              :default-value="
                (activeParent.mother && activeParent.mother.middleName) || ''
              "
            />
          </label>
        </span>
        <span class="span row">
          <label class="col-md-6">
            {{ $t("liste.telPere") }}
            <a-input
              id="telephonePere"
              type="text"
              name="telephonePere"
              :default-value="activeParent.father.phone"
            />
          </label>
          <label class="col-md-6">
            {{ $t("liste.telMere") }}
            <a-input
              id="telephoneMere"
              class="inp"
              type="text"
              name="telephoneMere"
              :default-value="activeParent.mother.phone"
            />
          </label>
        </span>
        <span class="span row">
          <label class="col-md-6">
            {{ $t("liste.metierPere") }}
            <a-input
              id="FonctionPere"
              type="text"
              name="FonctionPere"
              :default-value="activeParent.father.job"
            />
          </label>
          <label class="col-md-6">
            {{ $t("liste.metierMere") }}
            <a-input
              id="FonctionMere"
              class="inp"
              type="text"
              name="FonctionMere"
              :default-value="activeParent.mother.job"
            />
          </label>
        </span>
        <span class="span row">
          <label class="col-md-6">
            {{ $t("liste.emailPere") }}
            <a-input
              id="emailPere"
              type="text"
              name="emailPere"
              :default-value="activeParent.father.email"
            />
          </label>
          <label class="col-md-6">
            {{ $t("liste.emailMere") }}
            <a-input
              id="emailMere"
              type="text"
              name="emailMere"
              :default-value="activeParent.mother.email"
            />
          </label>
        </span>
        <div class="row justify-content-center border-with-text">
          <span class="border-text">{{ $t("menu.liste") }}</span>
          <a-list
            :grid="{
              gutter: activeStudentlist.length > 4 ? 12 : 24,
              column:
                activeStudentlist.length > 4 ? 4 : activeStudentlist.length,
            }"
            item-layout="v"
            :data-source="activeStudentlist"
            :bordered="false"
          >
            <a-list-item slot="renderItem" slot-scope="item, index">
              <a-list-item-meta
                @click="() => openProfile(item.id)"
                :description="item.description"
              >
                <a slot="title" :class="index">{{ item.title }}</a>
                <a-avatar
                  size="large"
                  slot="avatar"
                  v-if="item.photo"
                  :src="settings.resourcesUrl.replace('FILE_PATH', item.photo)"
                />
                <a-avatar
                  size="large"
                  slot="avatar"
                  style="color: #f56a00; background-color: #fde3cf"
                  v-else
                >
                  {{ item.title[0].toUpperCase() }}
                </a-avatar>
              </a-list-item-meta>
            </a-list-item>
          </a-list>
        </div>
      </div>
    </a-modal>

    <a-modal
      v-model="visibleAttestationPresence"
      :title="$t('all.enterInformationBelow')"
      :width="500"
      :key="'attPresence-' + (activeStudent ? activeStudent._id : 'default')"
    >
      <template slot="footer">
        <a-button
          key="back"
          @click="() => (this.visibleAttestationPresence = false)"
        >
          {{ $t("action.annuler") }}
        </a-button>
        <a-button
          type="primary"
          :loading="loadingData"
          :disabled="loadingData"
          @click="attestationPresencePDF(activeStudent)"
        >
          <img
            style="border-radius: 30%; margin-right: 5px"
            width="20"
            src="resources/images/flags/tunisia.svg"
            alt="Arabic"
          />
          {{ $t("action.imprimer") }}
        </a-button>
        <a-button
          type="primary"
          :loading="loadingData"
          :disabled="loadingData"
          @click="attestationPresenceFr(activeStudent)"
        >
          <img
            style="border-radius: 30%; margin-right: 5px"
            width="20"
            src="resources/images/flags/france.svg"
            alt="Arabic"
          />
          {{ $t("action.imprimer") }}
        </a-button>
      </template>
      <div>
        <span class="span">
          <label>
            {{ $t("liste.regionalEducation") }}
            <a-input
              id="cr"
              type="text"
              name="cr"
              :default-value="schoolDetails.delegeRegional"
            />
          </label>
        </span>
        <span class="span">
          <label>
            {{ $t("etablissement.headMaster") }}
            <a-input
              id="dir"
              type="text"
              name="dir"
              :default-value="schoolDetails.headMaster"
            />
          </label>
        </span>
        <span class="span">
          <label>
            {{ $t("bulletin.nom") }}
            <a-input
              id="nomStudent"
              type="text"
              name="nomStudent"
              :default-value="
                activeStudent.firstName + (activeStudent.middleName ? ' ' + activeStudent.middleName : '') + ' ' + activeStudent.lastName
              "
            />
          </label>
        </span>
        <span class="span" v-if="!isKenyanSchool()">
          <label>
            {{ $t("liste.identifiantUnique") }}
            <a-input
              id="uniqueIdStudent"
              type="text"
              name="uniqueIdStudent"
              :default-value="activeStudent.uniqueId || ''"
            />
          </label>
        </span>
        <span class="span" v-if="isKenyanSchool()">
          <label>
            {{ $t("profil.nemisNumber") }}
            <a-input
              id="nemisNumberStudent"
              type="text"
              name="nemisNumberStudent"
              :default-value="activeStudent.nemisNumber || ''"
            />
          </label>
        </span>
        <span class="span">
          <label>
            {{ $t("profil.dateNaissance") }}
            <a-form-item>
              <a-date-picker
                :placeholder="$t('profil.dateNaissance')"
                format="DD/MM/YYYY"
                :value="attestationPresenceBirthdate"
                @change="
                  (date) => {
                    attestationPresenceBirthdate = date;
                  }
                "
                v-decorator="[
                  'BirthDate',
                  {
                    rules: [
                      {
                        required: true,
                        message: $t('requis.dateNaissance'),
                      },
                    ],
                  },
                ]"
              />
            </a-form-item>
          </label>
        </span>
        <span class="span">
          <label>
            {{ $t("profil.classe") }}
            <a-input
              id="className"
              type="text"
              name="className"
              :default-value="activeStudent.scolarite"
            />
          </label>
        </span>

        <span class="span">
          <label>
            {{ $t("punition.raison") }}

            <a-input
              :placeholder="$t('punition.raison')"
              id="reason"
              name="reason"
              type="textarea"
              default-value="........................................"
              v-decorator="[
                'reason',
                {
                  trigger: ``,
                },
              ]"
            />
          </label>
        </span>

        <span class="span">
          <label>
            {{ $t("liste.recuEn") }}
            <a-input
              id="recuEn"
              type="text"
              name="recuEn"
              default-value="...................."
            />
          </label>
        </span>
        <span
          class="span"
          v-if="
            schoolDetails && schoolDetails.stamp && schoolDetails.stamp !== ''
          "
        >
          <label>
            {{ $t("bulletin.showStamp") }}
            <a-switch v-model="showStamp" class="ml-2" />
          </label>
        </span>
        <span class="span">
          <label>
            {{ $t("liste.showSchoolLogo") }}
            <a-switch v-model="showSchoolLogo" class="ml-2" />
          </label>
        </span>
        <span class="span">
          <label>
            {{ $t("liste.showGovLogo") }}
            <a-switch v-model="showGovLogo" class="ml-2" />
          </label>
        </span>
      </div>
    </a-modal>

    <a-modal
      v-model="visibleAttestationInscription"
      :title="$t('all.enterInformationBelow')"
      :width="500"
      :key="'attInscription-' + (activeStudentInscription ? activeStudentInscription._id : 'default')"
    >
      <template slot="footer">
        <a-button
          key="back"
          @click="closeAttestationInscriptionModal"
        >
          {{ $t("action.annuler") }}
        </a-button>
        <a-button
          type="primary"
          :loading="loadingData"
          :disabled="loadingData"
          @click="attestationInscriptionPDF(activeStudentInscription)"
        >
          {{ $t("action.imprimer") }}
        </a-button>
      </template>
      <div>
        <span class="span">
          <label>
            {{ $t("liste.recuEn") }}
            <a-input
              v-model="recuEnInscription"
              type="text"
              placeholder="...................."
            />
          </label>
        </span>
        <span
          class="span"
          v-if="
            schoolDetails && schoolDetails.stamp && schoolDetails.stamp !== ''
          "
        >
          <label>
            {{ $t("bulletin.showStamp") }}
            <a-switch v-model="showStampInscription" class="ml-2" />
          </label>
        </span>
      </div>
    </a-modal>

    <a-modal
      v-model="visibleLevelsSelection"
      :title="$t('all.printLoginCredentials')"
      :width="500"
      :key="'levels-' + componentKey"
    >
      <template slot="footer">
        <a-button key="back" @click="visibleLevelsSelection = false">
          {{ $t("action.annuler") }}
        </a-button>
        <a-button
          key="submit"
          type="primary"
          :loading="loadingLogins"
          :disabled="loadingLogins || (printSelectionMode === 'level' ? selectedLevels.length === 0 : selectedClasses.length === 0)"
          @click="confirmGenerateLogins"
        >
          {{ $t("action.confirmer") }}
        </a-button>
      </template>
      <div>
        <a-form-item :label="$t('liste.printSelectionMode')">
          <a-radio-group v-model="printSelectionMode" @change="handleSelectionModeChange" style="display: flex; flex-direction: row; gap: 16px;">
            <a-radio value="level">{{ $t('actualite.levels') }}</a-radio>
            <a-radio value="class">{{ $t('accueil.classes') }}</a-radio>
          </a-radio-group>
        </a-form-item>

        <a-form-item
          v-if="printSelectionMode === 'level'"
          :label="$t('actualite.levels')"
        >
          <a-select
            mode="multiple"
            :placeholder="$t('scolaritePdf.levels')"
            v-model="selectedLevels"
            style="width: 100%"
          >
            <a-select-option
              v-for="(value, name) in levelSelectData"
              :key="name"
              :value="name"
            >
              {{ value }}
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item
          v-if="printSelectionMode === 'class'"
          :label="$t('accueil.classes')"
        >
          <a-select
            mode="multiple"
            show-search
            :placeholder="$t('liste.classes')"
            option-filter-prop="children"
            :filter-option="filterOption"
            v-model="selectedClasses"
            style="width: 100%"
          >
            <a-select-option
              v-for="item in classRoomList"
              :key="item.id"
              :value="item.id"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </div>
    </a-modal>

    <!-- Modal for users without login credentials -->
    <a-modal
      v-model="visibleWithoutLoginModal"
      :title="$t('liste.studentsWithoutLogin')"
      :width="800"
      :key="'withoutLogin-' + componentKey"
    >
      <template slot="footer">
        <a-button
          key="back"
          @click="visibleWithoutLoginModal = false"
          :disabled="loadingLoginsConfirm"
        >
          {{ $t("action.annuler") }}
        </a-button>
        <a-button
          key="submit"
          type="primary"
          :loading="loadingLoginsConfirm"
          :disabled="loadingLoginsConfirm"
          @click="confirmGeneratePdfWithoutLogin"
        >
          {{ $t("liste.generatePdfAnyway") }}
        </a-button>
      </template>
      <div>
        <a-alert
          :message="$t('all.attention')"
          :description="
            withoutLoginType === 'parent'
              ? $t('liste.studentsWontAppearInPdf')
              : $t('liste.studentsWithoutLoginInfo')
          "
          :type="withoutLoginType === 'parent' ? 'warning' : 'info'"
          show-icon
          style="margin-bottom: 16px"
        />

        <a-table
          :columns="withoutLoginColumns"
          :data-source="withoutLoginData"
          :pagination="{ pageSize: 10 }"
          size="small"
          :scroll="{ y: 300 }"
        >
          <template slot="items" slot-scope="text, record">
            <div v-if="withoutLoginType === 'parent'">
              <div v-for="student in record.students" :key="student._id">
                <a-tag color="blue">
                  {{ student.fullName }}
                  <span v-if="student.classRoom"
                    >({{ student.classRoom.name }})</span
                  >
                </a-tag>
              </div>
            </div>
            <div v-else>
              <a-tag color="blue">
                {{ record.fullName }}
                <span v-if="record.classRoom">({{ record.classRoom }})</span>
              </a-tag>
            </div>
          </template>
        </a-table>
      </div>
    </a-modal>

    <!-- Modal for QR code generation errors - Simple warning -->
    <a-modal
      v-model="visibleQrCodeErrorModal"
      :title="$t('liste.qrCodeErrorWarning')"
      :width="600"
      :key="'qrError-' + componentKey"
      :footer="null"
    >
      <div>
        <a-alert
          :description="$t('liste.qrCodeErrorDescription')"
          type="warning"
          show-icon
          style="margin-bottom: 16px"
        />

        <div style="max-height: 300px; overflow-y: auto">
          <div
            v-for="user in qrCodeErrorData"
            :key="user._id"
            style="margin-bottom: 8px"
          >
            <div v-if="qrCodeErrorType === 'parent'">
              <strong>{{ user.fullName }}</strong>
              <span style="color: #1890ff; font-weight: normal">
                ({{ $t(`profil.${user.type}`) }})</span
              >
              <div
                v-if="user.students && user.students.length > 0"
                style="margin-left: 16px; font-size: 12px; color: #666"
              >
                <div v-for="student in user.students" :key="student._id">
                  • {{ student.fullName }}
                </div>
              </div>
            </div>
            <div v-else>
              <strong>{{ user.fullName }}</strong>
              <span v-if="user.classRoom" style="color: #666">
                ({{ user.classRoom }})</span
              >
            </div>
          </div>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
/* eslint-disable */
import router from "@/router";
import $ from "jquery";
import apiClient from "@/services/axios";
import JsPDF from "jspdf";
import { pdfHeader } from "@/utilities/pdfUtils";
import { mapState, mapActions, mapGetters } from "vuex";
import { getLevels } from "@/config/LevelConstants";
import "jspdf-autotable";
import { notification } from "ant-design-vue";
  import _ from "lodash";
  import { getRangeMonthsSY } from "@/utilities/settings";
import { getSchoolTypeLabel } from "@/utilities/buildingTypeLabel";
  import { uploadFilesToS3 } from "@/services/uploadService";
  import moment, { duration } from "moment";
import axios from "axios";
import { isKenyanSchool } from "@/utilities/countrySpecific";
import { generateSiblingsListPdf } from "@/utilities/siblingsListPdf";
import { showApiError } from "@/utilities/showApiError";

const { AwesomeQR } = require("awesome-qr");
const { generateAllLoginPdf } = require("@/utilities/pdfAllLogin");

function readbleDate(dateString) {
  const date = new Date(dateString);
  const dd = String(date.getDate()).padStart(2, "0");
  const mm = String(date.getMonth() + 1).padStart(2, "0"); //January is 0!
  const yyyy = date.getFullYear();
  return dd + "/" + mm + "/" + yyyy;
}
function parentFormater(parent) {
  return {
    name:
      parent.father.firstName +
      (parent.father.middleName ? " " + parent.father.middleName : "") +
      " " +
      parent.father.lastName +
      " et " +
      parent.mother.firstName +
      (parent.mother.middleName ? " " + parent.mother.middleName : "") +
      " " +
      parent.mother.lastName,
    children: parent.students ? parent.students.length : 0,
    motherPhone: parent.mother.phone,
    fatherPhone: parent.father.phone,
    id: parent._id,
  };
}
function flattenToDotNotation(obj, prefix = "") {
  const result = {};

  for (const [key, value] of Object.entries(obj)) {
    const fullKey = prefix ? `${prefix}.${key}` : key;

    if (value !== null && typeof value === "object" && !Array.isArray(value)) {
      Object.assign(result, flattenToDotNotation(value, fullKey));
    } else {
      result[fullKey] = value;
    }
  }

  return result;
}

export default {
  created() {
    this.$watch(
      () => this.settings.schoolarYears,
      (newValue, oldValue) => {
        this.init();
      }
    );

    const building = this.user.building.find(
      (el) => el.dbName == this.settings.activeBuilding
    );
    this.schoolType = building.type;

    try {
      this.loadingLogins = true;
      this.init();
      this.loadingLogins = false;
    } catch (error) {
      console.error(
        "Failed on load ,error handling strategy...",
        error.message
      );
    }
  },
  data() {
    return {
      selectedClassRoom: undefined,
      birthCertificateFileList: [],
      birthCertificateFile: null,
      suggestionTimeout: null,
      loadingLogins: true,
      suggestionParentList: [],
      selectedSuggestionParent: undefined,
      visibleParentSuggestion: false,
      visibleDeleteReasson: false,
      deleteReason: "",
      schoolDetails: {},
      loadingLoginsConfirm: false,
      componentKey: 0,
      disabledSP: false,
      activeBuilding: {},
      filtredTable: [],
      tableLeading: true,
      newStudentForm: this.$form.createForm(this),
      newParentOnlyForm: this.$form.createForm(this, { name: "newParentOnly" }),
      loadingAddParent: false,
      newStudent: {
        birthDate: null,
        gender: null,
        classRoom: null,
        parent: null,
      },
      classRoomList: [],
      newParent: false,
      addNewParent: false,
      parentsList: [],
      parentsCount: 0,
      activeParentChange: {},
      activeStudent: {},
      attestationPresenceBirthdate: null,
      activeParent: {
        father: {
          firstname: "",
          lastName: "",
          middleName: "",
          job: "",
          email: "",
        },
        mother: {
          firstname: "",
          lastName: "",
          middleName: "",
          job: "",
          email: "",
        },
        students: [
          {
            firstName: "",
            lastName: "",
            _id: "",
          },
        ],
      },
      activeStudentlist: [],
      editingKey: "",
      visibleParentFile: false,
      visibleAttestationPresence: false,
      visibleAttestationInscription: false,
      activeStudentInscription: null,
      recuEnInscription: "",
      visibleLevelsSelection: false,
      visibleWithoutLoginModal: false,
      withoutLoginData: [],
      allData: [],
      withoutLoginType: "parent", // "parent" or "student"
      visibleQrCodeErrorModal: false,
      qrCodeErrorData: [],
      qrCodeErrorType: "parent", // "parent", "student"
      withoutLoginColumns: [
        {
          title: this.$t("menu.eleves"),
          dataIndex: "items",
          key: "items",
          scopedSlots: { customRender: "items" },
        },
      ],
      currentLoginType: "parent", // "parent" or "student"
      data: [],
      cacheData: null,
      searchQuery: "",
      searchInput: null,
      searchedColumn: "",
      targetKeys: [],
      currentYear: "",
      currentYearFormatted: "",
      value: 1,
      value1: 1,
      loadingData: false,
      visibleData: false,
      loadingBadges: false,
      loadingSiblingsPdf: false,
      modePaiement: "M",
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: false,
      },
      stats: {
        enrolled: 0,
        nonEnrolled: 0,
        malePercentage: 0,
        femalePercentage: 0,
      },
      showStamp: true,
      showStampInscription: true,
      showSchoolLogo: true,
      showGovLogo: true,
      schoolType: null,
      selectedLevels: [],
      selectedClasses: [],
      printSelectionMode: "level", // "level" or "class"
      photoMediaConsentFilter: "all",
    };
  },
  computed: {
    ...mapState(["settings", "user"]),
    ...mapGetters("settings", ["btnAccessGetter", "packDetailsGetter"]),
    activeBuilding() {
      return this.user.building.find(
        (el) => el.dbName == this.settings.activeBuilding
      );
    },
    countryCode() {
      return this.activeBuilding?.countryCode;
    },
    levelSelectData() {
      return getLevels(this.$t.bind(this), this.schoolType, this.countryCode);
    },
    countryIsTN() {
      const building = this.user?.building?.find(
        (el) => el.dbName == this.settings?.activeBuilding
      );
      return building?.countryCode === "TN";
    },
    shouldRequireBirthCertificate() {
      if (!isKenyanSchool()) return false;
      if (this.selectedClassRoom && this.selectedClassRoom.level !== undefined) {
        return this.selectedClassRoom.level >= 3;
      }
      return false;
    },
    columns() {
      const cols = [
        {
          title: this.$t("liste.fullName"),
          dataIndex: "firstName",
          key: "firstName",
          scopedSlots: {
            customRender: "firstName",
          },
        },
        {
          title: this.$t("liste.scolarite"),
          dataIndex: "scolarite",
          key: "scolarite",
          scopedSlots: {
            customRender: "scolarite",
          },
        },
      ];
      if (isKenyanSchool()) {
        cols.push({
          title: this.$t("liste.photoMediaConsent"),
          dataIndex: "parentPhotoMediaConsent",
          key: "photoMediaConsent",
          scopedSlots: {
            customRender: "photoMediaConsent",
          },
        });
      }
      cols.push(
        {
          title: this.$t("liste.attestation"),
          dataIndex: "attestationPresence",
          key: "attestationPresence",
          scopedSlots: {
            customRender: "attestationPresence",
          },
        },
        {
          title: this.$t("liste.inscription"),
          dataIndex: "inscription",
          key: "inscription",
          scopedSlots: {
            customRender: "inscription",
          },
        },
        {
          title: this.$t("liste.supprimerAnnuler"),
          dataIndex: "delete",
          scopedSlots: { customRender: "delete" },
          fixed: "right",
        }
        /*{
          title: "Paiement",
          dataIndex: "payment",
          scopedSlots: { customRender: "payment" },
          fixed: "right",
        },*/
      );
      return cols;
    },
    countGarcon: function () {
      return this.stats.malePercentage || 0;
    },
    countFille: function () {
      return this.stats.femalePercentage || 0;
    },
    schoolAccessTemplateID() {
      //specefic template
      const accessTemplates = [{ id: "AC", dbName: "arcEnCiel2" }];
      let templateId = accessTemplates.find(
        (e) => e.dbName == this.schoolDetails.dbName
      );
      templateId = templateId ? templateId.id : "";
      return templateId;
    },
  },
  methods: {
    handlePhoneError(error) {
      this.$message.error(error);
    },
    handlePhoneChange(e164Phone) {
      this.newStudentForm.setFieldsValue({
        phone: e164Phone
      });
    },
    handleFatherPhoneChange(e164Phone) {
      this.newStudentForm.setFieldsValue({
        'parentdata.father.phone': e164Phone
      });
    },
    handleMotherPhoneChange(e164Phone) {
      this.newStudentForm.setFieldsValue({
        'parentdata.mother.phone': e164Phone
      });
    },
    handleNewParentFatherPhoneChange(e164Phone) {
      this.newParentOnlyForm.setFieldsValue({
        "father.phone": e164Phone,
      });
    },
    handleNewParentMotherPhoneChange(e164Phone) {
      this.newParentOnlyForm.setFieldsValue({
        "mother.phone": e164Phone,
      });
    },
    isKenyanSchool,
    onSearch(value) {
      this.searchQuery = value;
      this.pagination.current = 1; // Reset to first page when searching
      this.fetchStudents();
    },
    onPhotoMediaConsentFilterChange() {
      this.pagination.current = 1;
      this.fetchStudents();
    },
    changeModeP(v) {
      this.modePaiement = v;
    },
    addToBirthCertificateList(options) {
      const { onSuccess, onError, file, onProgress } = options;
      this.birthCertificateFile = file;
      setTimeout(() => {
        onSuccess(null, file);
      }, 200);
    },
    beforeUploadBirthCertificate(file) {
      const allowedTypes = [
        "image/jpeg",
        "image/jpg",
        "image/png",
        "image/webp",
        "application/pdf",
      ];

      const isValidType = allowedTypes.includes(file.type);
      if (!isValidType) {
        this.$message.error(this.$t("error.onlyImagesAndPDFAllowed"));
        return false;
      }

      const islt5M = file.size / 1024 / 1024 < 5;
      if (!islt5M) {
        this.$message.error(this.$t("error.fileTooLarge"));
        return false;
      }

      if (isValidType && islt5M) {
        this.$message.success(
          this.$t("success.imageTelecharge", { name: file.name })
        );
        this.birthCertificateFile = file;
      }
      return isValidType && islt5M;
    },
    handleChangeBirthCertificate(e) {
      if (e.file) {
        const allowedTypes = [
          "image/jpeg",
          "image/jpg",
          "image/png",
          "image/webp",
          "application/pdf",
        ];

        const isValidType = allowedTypes.includes(e.file.type);
        const islt5M = e.file.size / 1024 / 1024 < 5;

        if (isValidType && islt5M) {
          // Only keep the last file - single upload only
          this.birthCertificateFileList = e.fileList.slice(-1);
          e.file.status = "done";
        }
      }
    },
    async init() {
      const schoolYear = this.settings.schoolarYears.find(
        (sc) => sc._id == this.settings.activeSchoolarYear
      );
      this.currentYear = schoolYear?.name || "";
      if (schoolYear && schoolYear.start && schoolYear.end) {
        const startYear = new Date(schoolYear.start).getFullYear();
        const endYear = new Date(schoolYear.end).getFullYear();
        this.currentYearFormatted = `${startYear}/${endYear}`;
      } else {
        this.currentYearFormatted = "";
      }
      this.activeBuilding = this.settings.image.find(
        (building) => building.dbName == this.settings.activeBuilding
      );
      this.schoolDetails = this.user.building.find(
        (el) => el.dbName == this.settings.activeBuilding
      );
      this.tableLeading = true;
      apiClient
        .post("/classrooms/filter", {
          query: {
            status: "active",
            includeAffectation: true,
          },
          aggregation: {
            $project: {
              _id: 1,
              name: 1,
              inscription: 1,
              monthly: 1,
              tranches: 1,
              classroomType: 1,
            },
          },
        })
        .then((res) => {
          this.classRoomList = res.data.map((item) => ({
            name: item.name,
            id: item._id,
            inscription: item.inscription,
            monthly: item.monthly,
            tranches: item.tranches,
            classroomType: item.classroomType,
          }));
        });
      apiClient
        .post("/parents/filter", {
          query: { status: "active" },
          aggregation: {
            $project: {
              father: { firstName: 1, middleName: 1, lastName: 1, phone: 1 },
              mother: { firstName: 1, middleName: 1, lastName: 1, phone: 1 },
              students: 1,
              status: 1,
              financialStatus: 1,
              numberOfChildren: 1,
              adress: 1,
            },
          },
        })
        .then((res) => {
          this.parentsList = res.data.map((item) => parentFormater(item));
          this.parentsCount = res.data.filter(function (item) {
            return item.status === "active" || !item.status;
          }).length;
        });
      this.fetchStudents();
    },
    verifyAccess: function (accessRoles) {
      const existing = this.user.access;
      if (existing.all) return true;
      if (
        existing.liste_eleves === true ||
        (existing.liste_eleves &&
          existing.liste_eleves.length > 0 &&
          existing.liste_eleves.find((e) => accessRoles.includes(e)))
      )
        return true;
      else return false;
    },
    moment,
    debounceField: _.debounce(function (e) {
      let field = e.target.id;
      this.newStudentForm.setFieldsValue({
        [field]: e.target.value,
      });
      this.newStudentForm.validateFields([`${field}`]);
    }, 50),

    disabledDate(current) {
      // Can not select days before today and today
      return current && current > moment().endOf("day");
    },
    tableChanged(pagination, filters, sorter, extra) {
      this.filtredTable = extra.currentDataSource;
      // Handle pagination change
      if (pagination.current !== this.pagination.current || pagination.pageSize !== this.pagination.pageSize) {
        this.pagination.current = pagination.current;
        this.pagination.pageSize = pagination.pageSize;
        this.fetchStudents();
      }
    },
    async fetchStudents() {
      this.tableLeading = true;
      try {
        const params = {
          page: this.pagination.current,
          limit: this.pagination.pageSize,
        };

        // Add search query if it exists
        if (this.searchQuery) {
          params.search = this.searchQuery;
        }

        if (
          isKenyanSchool() &&
          this.photoMediaConsentFilter &&
          this.photoMediaConsentFilter !== "all"
        ) {
          params.photoMediaConsent = this.photoMediaConsentFilter;
        }

        const response = await apiClient.get("/students/list", { params });

        this.data = response.data.data.map((item) => this.studentFormater(item));
        this.cacheData = this.data;
        this.filtredTable = this.data;

        this.pagination.total = response.data.pagination.total;

        // Update stats
        if (response.data.stats) {
          this.stats.enrolled = response.data.stats.enrolled;
          this.stats.nonEnrolled = response.data.stats.nonEnrolled;
          this.stats.malePercentage = response.data.stats.malePercentage;
          this.stats.femalePercentage = response.data.stats.femalePercentage;
        }

        this.tableLeading = false;
      } catch (error) {
        this.$message.error(this.$t("error.fetchingStudents"));
        this.tableLeading = false;
      }
    },
    openImport() {
      router.push({ path: "/uploadeleves" }).catch((error) => {
        console.info(error);
      });
    },
    openArchive() {
      router.push({ path: "/archive_elevesliste" }).catch((error) => {
        console.info(error);
      });
    },
    openProfile(id) {
      router.push(`/eleve/${id}`).catch((error) => {
        console.info(error);
      });
    },
    studentFormater(student) {
      var modified = student;
      modified.BirthDate = readbleDate(modified.BirthDate);
      modified.createdAt = readbleDate(modified.createdAt);
      modified.id = student._id;
      // Ensure fullName includes middleName if virtual doesn't provide it
      if (!modified.fullName) {
        modified.fullName = student.firstName + (student.middleName ? " " + student.middleName : "") + " " + student.lastName;
      }
      return {
        ...modified,
        scolarite: student.classRoom
          ? student.classRoom
          : this.$t("liste.nonInscrit"),
      };
    },
    updateParent() {
      const id = this.activeParent._id;
      this.loadingData = true;
      const update = {
        father: {
          firstName: $("#nomPere").val(),
          middleName: $("#middleNamePere").val() || "",
          lastName: $("#prenomPere").val(),
          job: $("#FonctionPere").val(),
          phone: $("#telephonePere").val(),
          email: $("#emailPere").val(),
          adress: $("#adressPere").val(),
        },
        mother: {
          firstName: $("#nomMere").val(),
          middleName: $("#middleNameMere").val() || "",
          lastName: $("#prenomMere").val(),
          job: $("#FonctionMere").val(),
          phone: $("#telephoneMere").val(),
          email: $("#emailMere").val(),
          adress: $("#adressMere").val(),
        },
      };
      apiClient
        .patch(`/parents/${id}`, { data: flattenToDotNotation(update) })
        .then((res) => {
          this.data = this.data.map((student) =>
            student.parent[0]._id == id
              ? {
                  ...student,
                  parent: [
                    {
                      ...student.parent[0],
                      ...update,
                    },
                  ],
                }
              : student
          );
          this.parentsList = this.parentsList.map((parent) =>
            parent.id == id ? parentFormater({ ...update, _id: id }) : parent
          );
          this.$message.success(this.$t("success.parentMSA"));

          this.visibleParentFile = false;
          this.loadingData = false;
          //location.reload();
        })
        .catch(() => {
          this.visibleParentFile = false;
          this.loadingData = false;
          this.openNotificationWithIcon(
            "warning",
            this.$t("changementNonEffectue"),
            this.$t("champsVides")
          );
        });
    },
    triggerAddNewParent() {
      this.disabledSP = !this.disabledSP;
      // this.newParent = !this.newParent;
    },
    handleBlur() {},
    handleFocus() {},
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    parentFile(id) {
      this.componentKey += 1;
      this.activeParent = JSON.parse(JSON.stringify(id.parent[0]));
      //  this.activeStudentlist = this.activeParent.students.map((el) => {
      //    var description;
      //    var student = this.data.find((item) => item._id == el);
      //    /*  if (student.status == "active")
      //      description = student.classRoom
      //        ? `Inscrit au "${student.classRoom.name}"`
      //        : "Ne pas encore inscrit";
      //    else description = "Cet élève a été supprimé"; */
      //    return {
      //      id: student._id,
      //      title: student.firstName + " " + student.lastName,

      //      photo: student.photo,
      //    };
      //  });
      this.activeStudentlist = this.activeParent.students.reduce(
        (toReturn, studentID) => {
          var student = this.data.find((item) => item._id == studentID);
          if (student)
            toReturn.push({
              id: student._id,
              title:
                student.firstName +
                (student.middleName ? " " + student.middleName : "") +
                " " +
                student.lastName,
              photo: student.photo,
            });
          return toReturn;
        },
        []
      );

      this.visibleParentFile = true;
    },
    attestationPresence(id) {
      if (id) {
        this.activeParent = JSON.parse(JSON.stringify(id.parent[0]));
        this.activeStudent = id;
        this.attestationPresenceBirthdate = id.BirthDate
          ? moment(id.BirthDate, "DD/MM/YYYY")
          : null;
        this.activeStudentlist = this.activeParent.students
          .map((el) => this.data.find((item) => item._id == el))
          .filter((student) => student)
          .map((student) => ({
            id: student._id,
            title: student.firstName + " " + student.lastName,
            photo: student.photo,
          }));

        this.showStamp = true;
        this.visibleAttestationPresence = true;
      }
    },
    attestationInscription(record) {
      if (record) {
        this.activeStudentInscription = record;
        this.visibleAttestationInscription = true;
      }
    },
    closeAttestationInscriptionModal() {
      this.visibleAttestationInscription = false;
      this.showStampInscription = true;
      this.recuEnInscription = "";
    },
    handleChange(value, id, column) {
      const newData = [...this.data];
      const target = newData.filter((item) => id === item.id)[0];
      if (target) {
        target[column] = value;
        this.data = newData;
      }
    },
    edit(id) {
      const newData = [...this.data];
      const target = newData.filter((item) => id === item.id)[0];
      this.editingKey = id;
      if (target) {
        target.editable = true;
        this.data = newData;
        this.cacheData = this.data;
      }
    },
    save(id) {
      const newData = [...this.data];
      const newCacheData = [...this.cacheData];
      const target = newData.filter((item) => id === item.id)[0];
      const targetCache = newCacheData.filter((item) => id === item.id)[0];
      if (target && targetCache) {
        delete target.editable;
        this.data = newData;
        Object.assign(targetCache, target);
        this.cacheData = newCacheData;
        const update = {
          firstName: target.firstName,
          middleName: target.middleName,
          lastName: target.lastName,
          phone: target.phone,
          adress: target.adress,
        };
        apiClient
          .patch(`/students/${id}`, { data: update })
          .then()
          .catch(() => {
            this.openNotificationWithIcon(
              "warning",
              this.$t("changementNonEffectue")
            );
          });
      }
      this.editingKey = "";
    },
    cancel(id) {
      const newData = [...this.data];
      const target = newData.filter((item) => id === item.id)[0];
      this.editingKey = "";
      if (target) {
        Object.assign(
          target,
          this.cacheData.filter((item) => id === item.id)[0]
        );
        delete target.editable;
        this.data = newData;
      }
    },

    deleteStudent(id) {
      this.selectedStudentId = id;
      this.visibleDeleteReasson = true;
    },

    onDelete() {
      const id = this.selectedStudentId;
      this.visibleDeleteReasson = false;
      apiClient
        .delete(`/students/${id}`, {
          data: {
            reasonArchive: this.deleteReason,
          },
        })
        .then((res) => {
          const dataSource = [...this.data];
          this.data = dataSource.filter((item) => item.id !== id);
          this.cacheData = this.data;
          this.openNotificationWithIcon(
            "success",
            this.$t("success.eleveSupp")
          );
        })
        .catch((e) => this.$message.warning(this.$t("error.supp")))
        .finally(() => {
          this.deleteReason = "";
        });
    },
    onCancelInscription(id) {
      apiClient
        .post(`/payment/scolarite/cancel/${id}`)
        .then((res) => {
          const dataSource = [...this.data];
          let objIndex = this.data.findIndex((obj) => obj.id == id);
          this.data[objIndex].scolarite = "Non inscrit";
          this.cacheData = this.data;
          this.$emit("reload");
          this.openNotificationWithIcon(
            "success",
            this.$t("success.InscriptionAnnulee")
          );
        })
        .catch((e) => {
          if (e.response && e.response.data && e.response.data.errorCode) {
            this.$message.error(
              this.$t(`errorCode.${e.response.data.errorCode}`)
            );
          } else {
            this.$message.error(this.$t("error.InscriptionAnnulee"));
          }
        });
    },
    async addStudent(e) {
      this.newStudentForm.setFields({
        [parent]: { errors: [] },
      });
      this.newStudentForm.validateFieldsAndScroll(async (err, values) => {
        if (!err) {
          // --- Phone validation for TN/KE ---
          const phonesToCheck = [
            { value: values.phone, label: this.$t('liste.telephone') },
          ];
          if (this.newParent && values.parentdata) {
            if (values.parentdata.father && values.parentdata.father.phone) {
              phonesToCheck.push({ value: values.parentdata.father.phone, label: this.$t('liste.telPere') });
            }
            if (values.parentdata.mother && values.parentdata.mother.phone) {
              phonesToCheck.push({ value: values.parentdata.mother.phone, label: this.$t('liste.telMere') });
            }
          }
          for (const entry of phonesToCheck) {
            const phone = (entry.value || "").trim();
            if (!phone) continue;
            const digits = phone.replace(/\D/g, "");
            if (phone.startsWith("+216") && digits.length !== 11) {
              this.$message.error(`${entry.label}: ${this.$t('requis.telephone')}`);
              return;
            }
            if (phone.startsWith("+254") && digits.length !== 13) {
              this.$message.error(`${entry.label}: ${this.$t('requis.telephoneKE')}`);
              return;
            }
          }
          // --- End phone validation ---

          // this.loadingData = true;
          let student = values;

          if (this.birthCertificateFile) {
            try {
              const progressBar = { value: 0 };
              const uploadedKeys = await uploadFilesToS3(
                [this.birthCertificateFile],
                "manager/student/birthCertificate",
                progressBar
              );
              student.birthCertificate = uploadedKeys[0];
            } catch (error) {
              console.error("Birth certificate upload failed:", error);
              this.$message.error(this.$t("error.fileUploadError"));
              return;
            }
          }

          // Handle SACCO fields transformation
          if (student.saccoName || student.saccoBankName) {
            student.sacco = {
              name: student.saccoName || "",
              bankDetails: {
                name: student.saccoBankName || "",
              },
            };
            delete student.saccoName;
            delete student.saccoBankName;
          }
          const healthInfo = {};
          const formHealthInfo = student.healthInfo || values.healthInfo || {};

          if (formHealthInfo.bloodType) healthInfo.bloodType = formHealthInfo.bloodType;
          if (formHealthInfo.medicalCondition) healthInfo.medicalCondition = formHealthInfo.medicalCondition;
          if (formHealthInfo.allergies) healthInfo.allergies = formHealthInfo.allergies;
          if (formHealthInfo.parentNoteOnAllergies) healthInfo.parentNoteOnAllergies = formHealthInfo.parentNoteOnAllergies;

          // Only include healthInfo if it has at least one field
          if (Object.keys(healthInfo).length > 0) {
            student.healthInfo = healthInfo;
          } else {
            delete student.healthInfo;
          }

          student.schoolarYearsHistory = {};
          let studentNumberIns = 0;
          // if (values.classRoom && this.packDetailsGetter.studentLimit != -1) {
          //   await apiClient.get("/students/studentsCount").then(({ data }) => {
          //     studentNumberIns = data;
          //   });
          // }
          // if (studentNumberIns >= this.packDetailsGetter.studentLimit) {
          //   this.newStudentForm.resetFields();
          //   this.visibleData = false;
          //   this.loadingData = false;
          //   this.packHasBtnAccess(null);

          //   return;
          // }

          student.schoolarYearsHistory[this.settings.activeSchoolarYear] =
            values.classRoom ? values.classRoom : null;

          if (this.newParent) {
            const parentData = values.parentdata;
            delete values.parentdata;
            await apiClient
              .put("/students/student_parent", {
                ...values,
                parent: parentData,
              })
              .then((res) => {
                const data = res.data;
                this.parentsList.push(parentFormater(data.parent));
                this.data.push(this.studentFormater(data.student));
                student = data.student;
                this.$message.success(this.$t("success.eleveAjout"));
              })
              .catch((e) => {
                console.error(e);
                this.$message.warning(this.$t("error.ajout"));
              })
              .finally(() => {
                this.newStudentForm.resetFields();
                this.birthCertificateFileList = [];
                this.birthCertificateFile = null;
              });
            this.newParent = false;
          } else {
            await apiClient
              .put("/students/student_parent", student)
              .then((res) => {
                const studentRes = res.data.student;
                student = studentRes;
                this.data.push(this.studentFormater(studentRes));
                this.$message.success(this.$t("success.eleveAjout"));
              })
              .catch((e) => {
                console.error(e);
                this.$message.warning(this.$t("error.ajout"));
              })
              .finally(() => {
                this.newStudentForm.resetFields();
                this.birthCertificateFileList = [];
                this.birthCertificateFile = null;
              });
          }
          this.visibleData = false;
          this.loadingData = false;
          if (values.classRoom) {
            const activeSchoolarYear = this.settings.activeSchoolarYear;
            const schoolarYears = this.settings.schoolarYears;
            let newInscription = {};
            schoolarYears.forEach((elem) => {
              if (elem._id == activeSchoolarYear) {
                newInscription.end = elem.end;
                newInscription.start = elem.start;
              }
            });
            newInscription.student = student._id;
            newInscription.typeAS = "S";
            newInscription.classroom = values.classRoom;
            newInscription.mode = this.modePaiement;

            let repReduction = {};

            const range = getRangeMonthsSY(activeSchoolarYear, schoolarYears);
            if (newInscription.mode == "M")
              for (const key of range) repReduction[key] = 0;
            else if (this.selectedClassRoom.tranches)
              for (const e of this.selectedClassRoom.tranches)
                repReduction[e.trancheNumber] = 0;

            if (this.selectedClassRoom.inscription)
              repReduction["inscription"] = 0;

            newInscription.repReduction = repReduction;

            apiClient
              .put(`/payment`, newInscription)
              .then((res) => {
                let className = this.classRoomList.find(
                  (e) => e.id == values.classRoom
                );
                this.data = this.data.map((e) => {
                  if (e.id === student._id) {
                    e.scolarite =
                      className && className.name ? className.name : "--";
                    e.classroomType =
                      className && className.classroomType
                        ? className.classroomType
                        : null;
                  }
                  return e;
                });
              })
              .catch((error) => {
                if (error.response.status == 402) {
                  this.data = this.data.map((e) => {
                    if (e.id === student._id) {
                      e.scolarite = "--";
                    }
                    return e;
                  });
                  //pack student limit number reached
                  this.packHasBtnAccess(null);
                }
              });
          }
        }
      });
    },
    handleCancelModalAdd(e) {
      this.visibleData = false;
      this.selectedClassRoom = undefined;
    },
    handleCancelAddParent() {
      this.addNewParent = false;
      this.loadingAddParent = false;
      this.newParentOnlyForm.resetFields();
    },
    showAddParentModal() {
      this.addNewParent = true;
      this.$nextTick(() => {
        this.newParentOnlyForm.resetFields();
      });
    },
    addParentOnly(e) {
      if (e && e.preventDefault) e.preventDefault();
      this.newParentOnlyForm.validateFieldsAndScroll(async (err, values) => {
        if (err) return;
        this.loadingAddParent = true;
        try {
          const { data } = await apiClient.post("/parents/without-student", {
            parent: {
              father: values.father,
              mother: values.mother,
            },
          });
          if (data && data.parent) {
            this.parentsList.push(parentFormater(data.parent));
            this.parentsCount += 1;
          }
          this.$message.success(this.$t("success.parentAjout"));
          this.handleCancelAddParent();
        } catch (error) {
          showApiError(this, error);
        } finally {
          this.loadingAddParent = false;
        }
      });
    },
    handleCancelModalParent(e) {
      this.visibleParentFile = false;
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    // Function to add a new page with sections
    addPageWithSections(pdf, index) {
      if (index > 0 && index % 4 === 0) {
        pdf.addPage();
      }
      // Define the page size (A4)
      const pageWidth = 210;
      const pageHeight = 297;

      // Define section dimensions
      const sectionWidth = pageWidth / 2;
      const sectionHeight = pageHeight / 2;
      // Draw section borders on the new page
      pdf.rect(0, 0, sectionWidth, sectionHeight);
      pdf.rect(sectionWidth, 0, sectionWidth, sectionHeight);
      pdf.rect(0, sectionHeight, sectionWidth, sectionHeight);
      pdf.rect(sectionWidth, sectionHeight, sectionWidth, sectionHeight);
    },
    // Function to add image to the top right corner of a section
    addImageToSection(pdf, x, y, width, height, imgData) {
      pdf.addImage(imgData, "JPEG", x, y, width, height);
    },
    async drawSection(pdf, parent, index, logo, imgData, schoolName) {
      pdf.setPage(Math.floor(index / 4) + 1);
      // Define the page size (A4)
      const pageWidth = 210;
      const pageHeight = 297;

      // Define section dimensions
      const sectionWidth = pageWidth / 2;
      const sectionHeight = pageHeight / 2;
      // Calculate section coordinates
      const x = (index % 2) * sectionWidth;
      const y = (Math.floor(index / 2) % 2) * sectionHeight;
      //add building logo
      const imageWidth = 15;
      const imageHeight = 15;
      //add qrcode image

      const qrData = window.btoa(parent.token + "#" + this.settings.base_url);

      let students = parent.students
        .map((s) => {
          if (s.classRoom && s.classRoom.name)
            return s.fullName + " (" + s.classRoom.name + " )";
          return s.fullName;
        })
        .join("\n");
      pdf.setFont("Amiri", "bold");

      pdf.setFontSize(15);

      pdf.text(`${this.$t("liste.concInfo")}`, x + 15, y + 15);
      pdf.setFont("Amiri", "normal");
      pdf.setFontSize(12);

      pdf.text(schoolName, x + 50, y + 20, "center");

      pdf.setFontSize(10);

      // Add content to the section
      let preText = `${this.$t("profil.father")} : `;
      if (parent.type === "mother") preText = `${this.$t("profil.mother")} : `;
      if (parent.type === "guardian")
        preText = `${this.$t("profil.guardian")} : `;
      pdf.text(
        `${this.$t("profil.nom")} ${preText} ${
          parent.lastName ? this.capitalizeFirstLetter(parent.lastName) : "--"
        }`,
        x + 10,
        y + 32
      );
      pdf.text(
        `${this.$t("profil.prenom")} ${preText} ${
          parent.firstName ? this.capitalizeFirstLetter(parent.firstName) : "--"
        }`,
        x + 10,
        y + 40
      );
      pdf.text(`${this.$t("liste.elevesAssocies")} : `, x + 10, y + 48);

      pdf.text(`${students}`, x + 40, y + 48);
      const textChildrenDims = pdf.getTextDimensions(students);

      pdf.text(
        `${this.$t("liste.linkConnection")} :`,
        x + 10,
        y + 56 + textChildrenDims.h
      );
      pdf.text(
        `https://parent.edtrust.tn/ \n${this.$t("liste.linkConnectiontext")}`,
        x + 39,
        y + 56 + textChildrenDims.h
      );
      pdf.text(
        `${this.$t("profil.nomUser")} : ${parent.userName}`,
        x + 10,
        y + 64 + textChildrenDims.h + 3
      );

      // Add QR code

      await new AwesomeQR({
        text: qrData,
        logoImage: logo,
        size: 200,
        correctLevel: 1,
        logoScale: 0.2,
        logoMargin: 0,
        logoCornerRadius: 8,
        whiteMargin: false,
        dotScale: 1,
        autoColor: true,
        binarize: false,
        binarizeThreshold: 128,
        backgroundColor: "#FFFFFF",
        margin: 3,
      })
        .draw()
        .then((dataURL) => {
          pdf.setPage(Math.floor(index / 4) + 1);

          pdf.addImage(dataURL, "JPEG", x + 33, y + 90, 40, 40);
          this.addImageToSection(
            pdf,
            x + sectionWidth - imageWidth - 5,
            y + 5,
            imageWidth,
            imageHeight,
            imgData
          );
        });
    },
    showLevelsSelection() {
      this.currentLoginType = "parent";
      this.selectedLevels = [];
      this.selectedClasses = [];
      this.printSelectionMode = "level";
      this.visibleLevelsSelection = true;
    },
    showStudentLevelsSelection() {
      if (!this.btnAccessGetter.includes("printLoginsStudents")) return;
      this.currentLoginType = "student";
      this.selectedLevels = [];
      this.selectedClasses = [];
      this.printSelectionMode = "level";
      this.visibleLevelsSelection = true;
    },
    handleSelectionModeChange() {
      // Reset selections when switching modes
      this.selectedLevels = [];
      this.selectedClasses = [];
    },
    async generateLoginsParents(levels = null, classes = null) {
      this.loadingLogins = true;

      // Prepare query parameters
      const params = {};
      if (levels && levels.length > 0) {
        params.levels = levels.join(",");
      }
      if (classes && classes.length > 0) {
        params.classes = classes;
      }

      await apiClient
        .get("/parents/parentslogins", { params })
        .then(async (res) => {
          const parentsLogins = res.data;

          // Check which parents don't have login credentials
          const parentsWithoutLogin = parentsLogins.filter((parent) => {
            // A parent is considered to have no login if none of father, mother, or guardian have login data
            const hasFatherLogin =
              parent.father && parent.father.userName && parent.father.token;
            const hasMotherLogin =
              parent.mother && parent.mother.userName && parent.mother.token;
            const hasGuardianLogin =
              parent.guardian &&
              parent.guardian.userName &&
              parent.guardian.token;

            return !hasFatherLogin && !hasMotherLogin && !hasGuardianLogin;
          });

          // If there are parents without login, show them in a modal
          if (parentsWithoutLogin.length > 0) {
            this.withoutLoginType = "parent";
            this.withoutLoginData = parentsWithoutLogin;
            this.allData = parentsLogins;
            this.visibleWithoutLoginModal = true;
            this.loadingLogins = false;
            return;
          }

          // If all parents have login credentials, proceed with PDF generation
          await this.generatePdfWithParents(parentsLogins);
        });
    },

    async generatePdfWithParents(parentsLogins) {
      const result = await generateAllLoginPdf({
        parentsLogins,
        settings: this.settings,
        userType: "parent",
        t: this.$t.bind(this),
        locale: this.$i18n.locale,
      });

      if (result.qrCodeErrors && result.qrCodeErrors.length > 0) {
        this.qrCodeErrorType = "parent";
        this.qrCodeErrorData = result.qrCodeErrors.map((user) => ({
          fullName: `${user.firstName} ${user.lastName}`,
          type: user.type || "parent", // father, mother, guardian
          students: user.students || [],
          _id: user._id,
        }));
        this.visibleQrCodeErrorModal = true;
      }

      this.loadingLogins = false;
    },

    async confirmGeneratePdfWithoutLogin() {
      this.loadingLoginsConfirm = true;
      if (this.withoutLoginType === "parent") {
        // Generate PDF with all parents (the PDF utility will filter out parents without login automatically)
        await this.generatePdfWithParents(this.allData);
      } else {
        // Generate PDF with all students (the PDF utility will filter out students without login automatically)
        await this.generatePdfWithStudents(this.allData);
      }
      this.visibleWithoutLoginModal = false;
      this.loadingLoginsConfirm = false;
    },

    async generatePdfWithStudents(studentsLogins) {
      const result = await generateAllLoginPdf({
        parentsLogins: studentsLogins,
        settings: this.settings,
        userType: "student",
        t: this.$t.bind(this),
        locale: this.$i18n.locale,
      });

      if (result.qrCodeErrors && result.qrCodeErrors.length > 0) {
        this.qrCodeErrorType = "student";
        this.qrCodeErrorData = result.qrCodeErrors.map((user) => ({
          fullName: `${user.firstName} ${user.lastName}`,
          classRoom: user.classRoom ? user.classRoom.name : "",
          _id: user._id,
        }));
        this.visibleQrCodeErrorModal = true;
      }

      this.loadingLogins = false;
    },

    async generateStudentLogins(levels = null, classes = null) {
      this.loadingLogins = true;

      try {
        // Prepare query parameters
        const params = {};
        if (levels && levels.length > 0) {
          params.levels = levels.join(",");
        }
        if (classes && classes.length > 0) {
          params.classes = classes;
        }

        const response = await apiClient.get("/students/studentslogins", {
          params,
        });
        const studentsLogins = response.data;

        if (studentsLogins.length === 0) {
          this.$message.error("Aucun étudiant trouvé");
          return;
        }

        // Check which students don't have login credentials
        const studentsWithoutLogin = studentsLogins.filter((student) => {
          // A student is considered to have no login if they don't have userName and token
          return !student.userName || !student.token;
        });

        // If there are students without login, show them in a modal
        if (studentsWithoutLogin.length > 0) {
          this.withoutLoginType = "student";
          this.withoutLoginData = studentsWithoutLogin.map((student) => ({
            fullName: student.firstName + (student.middleName ? " " + student.middleName : "") + " " + student.lastName,
            classRoom: student.classRoom ? student.classRoom.name : "",
            _id: student._id,
          }));
          this.allData = studentsLogins;
          this.visibleWithoutLoginModal = true;
          this.loadingLogins = false;
          return;
        }

        // If all students have login credentials, proceed with PDF generation
        await this.generatePdfWithStudents(studentsLogins);
      } catch (error) {
        console.error("Error generating student logins:", error);
      } finally {
        this.loadingLogins = false;
      }
    },

    async drawBadge(doc, x, y, imgData, logo, student, pageNumber, schoolName) {
      doc.setPage(pageNumber);
      var today = new Date();
      const options = {
        year: "numeric",
        month: "numeric",
        day: "numeric",
      };
      doc.setFont("Amiri");
      doc.setFontSize(10);
      let birthDay = new Date(student.BirthDate);
      doc.setFont("Amiri", "Bold");
      doc.text(47 + x, 21 + y, this.$t("profil.fullname") + ": ");
      doc.setFont("Amiri", "normal");
      doc.setFontSize(9);
      doc.text(
        47 + x,
        27 + y,
        this.capitalizeFirstLetter(student.firstName + (student.middleName ? " " + student.middleName : "") + " " + student.lastName)
      );
      doc.setFontSize(10);
      doc.setFont("Amiri", "Bold");
      doc.text(47 + x, 33 + y, this.$t("profil.dateNaissance") + ": ");
      doc.setFont("Amiri", "normal");
      doc.text(47 + x, 39 + y, birthDay.toLocaleDateString("fr-FR", options));
      doc.setFontSize(5);
      doc.text(
        52 + x,
        47 + y,
        this.$t("liste.generated") +
          " " +
          today.toLocaleDateString("fr-FR", options)
      );

      let qrDataDetail =
        student._id +
        "." +
        this.settings.activeBuilding +
        "." +
        this.settings.activeSchoolarYear +
        "." +
        this.settings.base_url;

      const qrData = btoa(qrDataDetail);

      await new AwesomeQR({
        text: qrData,
        logoImage: logo,
        size: 200,
        correctLevel: 1,
        logoScale: 0.2,
        logoMargin: 0,
        logoCornerRadius: 8,
        whiteMargin: false,
        dotScale: 1,
        autoColor: true,
        binarize: false,
        binarizeThreshold: 128,
        bindElement: true,
        backgroundColor: "#FFFFFF",
        margin: 3,
      })
        .draw()
        .then((dataURL) => {
          doc.setPage(pageNumber);
          doc.addImage(dataURL, "JPEG", 7 + x, 15 + y, 30, 30);
          doc.addImage(imgData, "JPEG", 75 + x, 6 + y, 10, 10);
          doc.setFontSize(13);
          doc.text(schoolName, 46 + x, 11 + y, "center");

          doc.setFillColor(0, 0, 0);
          doc.rect(4 + x, 4 + y, 84, 48, "S");
        });
    },
    async drawNewBadge(
      doc,
      x,
      y,
      imgData,
      logo,
      student,
      pageNumber,
      schoolName,
      defaultStudentPhoto,
      classroom
    ) {
      doc.setPage(pageNumber);

      doc.setLineWidth(1);

      const backgroundColor = "#81b6f7";
      const lineColor = "#61a6fa";
      const photoColor = "#ffffff";

      const page_width = doc.internal.pageSize.getWidth() / 2;
      const page_height = doc.internal.pageSize.getHeight() / 2;
      const ctx = doc.context2d;

      doc.setFillColor(backgroundColor);
      doc.setDrawColor(lineColor);

      doc.rect(x + 0, y + 50, page_width, page_height - 50, "FD");

      doc.setFillColor(photoColor);
      doc.setDrawColor(lineColor);
      doc.setLineWidth(0.6);
      doc.circle(x + page_width / 2, y + 50, 20, "FD");

      // draw student photo
      // -------------------------------------------------------------
      const studentPhoto = new Image();
      if (student.photo)
        studentPhoto.src = this.settings.resourcesUrl.replace(
          "FILE_PATH",
          student.photo
        );

      let imageSize = 39; // Adjust this to the desired image size
      let centerX = x + page_width / 2; // Adjust this to the desired X coordinate
      let centerY = y + 50; // Adjust this to the desired Y coordinate

      // Create a circular clipping path using context2d
      ctx.save();
      ctx.beginPath();
      ctx.arc(centerX, centerY, imageSize / 2, 0, Math.PI * 2);
      ctx.clip();

      // Draw the original image within the circular clipping path
      ctx.drawImage(
        student.photo ? studentPhoto : defaultStudentPhoto,
        centerX - imageSize / 2,
        centerY - imageSize / 2,
        imageSize,
        imageSize
      );

      // Reset the clipping path
      ctx.restore();
      ctx.closePath();
      // -------------------------------------------------------------

      doc.setFont("Amiri", "Bold");
      doc.setFontSize(22);
      doc.setTextColor("#ffffff");

      doc.text(
        x + page_width / 2,
        y + 78,
        this.capitalizeFirstLetter(student.firstName + (student.middleName ? " " + student.middleName : "") + " " + student.lastName),
        { align: "center" }
      );
      doc.setFont("Amiri", "normal");
      doc.setFontSize(15);
      doc.text(x + page_width / 2, y + 88, classroom, {
        align: "center",
      });

      let qrDataDetail =
        student._id +
        "." +
        this.settings.activeBuilding +
        "." +
        this.settings.activeSchoolarYear +
        "." +
        this.settings.base_url;

      const qrData = btoa(qrDataDetail);

      await new AwesomeQR({
        text: qrData,
        logoImage: logo,
        size: 200,
        correctLevel: 1,
        logoScale: 0.2,
        logoMargin: 0,
        logoCornerRadius: 8,
        whiteMargin: false,
        dotScale: 1,
        autoColor: true,
        binarize: false,
        binarizeThreshold: 128,
        bindElement: true,
        backgroundColor: "#FFFFFF",
        margin: 3,
      })
        .draw()
        .then((dataURL) => {
          doc.setPage(pageNumber);
          doc.addImage(
            dataURL,
            "PNG",
            x + (page_width / 2 - 17.5),
            y + page_height / 1.5,
            35,
            35
          );

          // logo and school name
          // -------------------------------------------------------------
          imageSize = 15;
          const text = schoolName;
          centerX = page_width / 2;
          centerY = y + 15;
          const padding = 5;
          doc.setFontSize(13);

          const totalWidth = imageSize + padding + doc.getTextWidth(text);
          const startX = x + centerX - totalWidth / 2;

          doc.addImage(
            imgData,
            "JPEG",
            startX,
            centerY - imageSize / 2,
            imageSize,
            imageSize
          );

          doc.setTextColor("#000000");

          doc.text(startX + imageSize + padding, centerY, text);
          doc.setFillColor(0, 0, 0);
          doc.setLineWidth(0.5);
          doc.rect(x, y, page_width, page_height, "S");
          // -------------------------------------------------------------
        });
    },
    async generateBadges() {
      if (!(await this.packHasBtnAccess("prBadge"))) return;
      this.$gtag.event("Imprimer les badges ", {
        event_category: "Impression PDF",
        event_label: "Liste des élèves section",
        value: 1,
      });

      const start = performance.now();
      this.loadingBadges = true;
      const doc = new JsPDF();
      const pdf_height = doc.internal.pageSize.height;
      const pdf_width = doc.internal.pageSize.width;

      doc.setFont("Amiri");

      let schoolLogo = null;
      let arrayOfImages = this.settings.image;
      for (var i = 0; i < arrayOfImages.length; i++) {
        if (this.settings.activeBuilding === arrayOfImages[i].db) {
          var imgSrc = arrayOfImages[i].logo;
          schoolLogo = arrayOfImages[i].logo;
        }
      }

      const schoolDetails = this.user.building.filter(
        (el) => el.dbName == this.settings.activeBuilding
      )[0];

      const schoolName = schoolDetails.ArabicName || schoolDetails.name;

      let imgData = "data:image/jpeg;base64, ";

      await axios
        .get(imgSrc, {
          responseType: "arraybuffer",
        })
        .then((response) => {
          imgData += Buffer.from(response.data, "binary").toString("base64");
        });

      const data = {};
      let logo = "data:image/jpeg;base64, ";

      await axios
        .get(schoolLogo || "favicon.png", {
          responseType: "arraybuffer",
        })
        .then((response) => {
          logo += Buffer.from(response.data, "binary").toString("base64");
        });

      this.filtredTable.forEach((student) => {
        if (!data[student.classRoom]) data[student.classRoom] = [];
        data[student.classRoom].push(student);
      });

      let y = 0;
      let left = true;
      let firstPage = true;
      let currentPage = 1;

      // array for optimization
      const promises = [];

      for (const classroom of Object.keys(data)) {
        doc.setFontSize(17);
        y = 15;
        if (!firstPage) {
          doc.addPage();
          currentPage++;
          left = true;
        }
        const width = doc.getTextWidth(classroom);
        doc.text(classroom, pdf_width / 2 - width / 2, 10);
        const classroomData = data[classroom];
        for (let i = 0; i < classroomData.length; i++) {
          if (left)
            promises.push(
              this.drawBadge(
                doc,
                16,
                y,
                imgData,
                logo,
                classroomData[i],
                currentPage,
                schoolName
              )
            );
          else
            promises.push(
              this.drawBadge(
                doc,
                100,
                y,
                imgData,
                logo,
                classroomData[i],
                currentPage,
                schoolName
              )
            );

          if (!left) {
            y += 48.1;
            if (y + 68.1 >= pdf_height) {
              y = 0;
              left = false;
              doc.addPage();
              currentPage++;
            }
          }

          left = !left;
        }

        firstPage = false;
      }

      await Promise.all(promises)
        .then((values) => {
          //page numbering
          const pages = doc.internal.getNumberOfPages();
          const pageWidth = doc.internal.pageSize.width;
          const pageHeight = doc.internal.pageSize.height;
          doc.setFontSize(8); //Optional

          for (let j = 1; j < pages + 1; j++) {
            let horizontalPos = pageWidth / 2;
            let verticalPos = pageHeight - 5;
            doc.setPage(j);
            doc.text(
              this.$t("pdf.pageNumber", { current: j, total: pages }),
              horizontalPos,
              verticalPos,
              {
                align: "center",
              }
            );
          }

          this.loadingBadges = false;
          doc.save(this.$t("liste.listBadges") + ".pdf");
        })
        .catch((reason) => {
          console.log(reason);
        });
      const end = performance.now();
      this.$gtag.event("Imprimer les badges ", {
        event_category: "PRINT",
        print_what: "Liste des élèves section",
        duration: end - start,
      });
    },

    async generateNewBadges() {
      //upgrade
      if (!(await this.packHasBtnAccess("prBadgePhoto"))) return;

      this.$gtag.event("Imprimer les badges avec photos", {
        event_category: "Impression PDF",
        event_label: "Liste des élèves section",
        value: 1,
      });

      const start = performance.now();
      this.loadingBadges = true;
      const doc = new JsPDF();
      const pdf_height = doc.internal.pageSize.height;
      const pdf_width = doc.internal.pageSize.width;

      doc.setFont("Amiri");

      let schoolLogo = null;
      let arrayOfImages = this.settings.image;
      for (var i = 0; i < arrayOfImages.length; i++) {
        if (this.settings.activeBuilding === arrayOfImages[i].db) {
          var imgSrc = arrayOfImages[i].logo;
          schoolLogo = arrayOfImages[i].logo;
        }
      }

      const schoolDetails = this.user.building.filter(
        (el) => el.dbName == this.settings.activeBuilding
      )[0];

      const schoolName = schoolDetails.ArabicName || schoolDetails.name;

      let imgData = "data:image/jpeg;base64, ";

      await axios
        .get(imgSrc, {
          responseType: "arraybuffer",
        })
        .then((response) => {
          imgData += Buffer.from(response.data, "binary").toString("base64");
        });

      const data = {};
      let logo = "data:image/jpeg;base64, ";

      await axios
        .get(schoolLogo || "favicon.png", {
          responseType: "arraybuffer",
        })
        .then((response) => {
          logo += Buffer.from(response.data, "binary").toString("base64");
        });

      let defaultStudentPhoto = "data:image/jpeg;base64, ";

      await axios
        .get("/resources/images/blank.png", {
          responseType: "arraybuffer",
        })
        .then((response) => {
          defaultStudentPhoto += Buffer.from(response.data, "binary").toString(
            "base64"
          );
        });

      this.filtredTable.forEach((student) => {
        if (!data[student.classRoom]) data[student.classRoom] = [];
        data[student.classRoom].push(student);
      });

      let y = 0;
      let left = true;
      let firstPage = true;
      let currentPage = 1;

      // array for optimization
      const promises = [];

      for (const classroom of Object.keys(data)) {
        doc.setFontSize(17);
        y = 0;
        if (!firstPage) {
          doc.addPage();
          currentPage++;
          left = true;
        }
        const classroomData = data[classroom];
        for (let i = 0; i < classroomData.length; i++) {
          if (left)
            promises.push(
              this.drawNewBadge(
                doc,
                0,
                y,
                imgData,
                logo,
                classroomData[i],
                currentPage,
                schoolName,
                defaultStudentPhoto,
                classroom
              )
            );
          else
            promises.push(
              this.drawNewBadge(
                doc,
                pdf_width / 2,
                y,
                imgData,
                logo,
                classroomData[i],
                currentPage,
                schoolName,
                defaultStudentPhoto,
                classroom
              )
            );

          if (!left) {
            y += pdf_height / 2;
            if (y + 2 >= pdf_height) {
              y = 0;
              left = false;
              doc.addPage();
              currentPage++;
            }
          }

          left = !left;
        }

        firstPage = false;
      }

      await Promise.all(promises)
        .then((values) => {
          this.loadingBadges = false;
          doc.save(this.$t("liste.listBadges") + ".pdf");
        })
        .catch((reason) => {
          console.log(reason);
        });
      const end = performance.now();
      this.$gtag.event("Imprimer les badges avec photos", {
        event_category: "PRINT",
        print_what: "Liste des élèves section",
        duration: end - start,
      });
    },
    ...mapActions("settings", ["packHasBtnAccess"]),
    async generateSiblingsPdf() {
      if (!(await this.packHasBtnAccess("prStudentList"))) return;

      this.$gtag.event("Imp liste frères/sœurs", {
        event_category: "Impression PDF",
        event_label: "Liste des frères et sœurs",
        value: 1,
      });
      const start = performance.now();
      this.loadingSiblingsPdf = true;

      try {
        const { data } = await apiClient.get("/parents/siblings");

        if (!data || data.length === 0) {
          this.$message.warning(this.$t("liste.noSiblingGroups"));
          return;
        }

        generateSiblingsListPdf({
          groups: data,
          settings: this.settings,
          t: this.$t.bind(this),
          locale: this.$i18n.locale,
          nonInscritLabel: this.$t("liste.nonInscrit"),
        });

        const end = performance.now();
        this.$gtag.event("Imp liste frères/sœurs", {
          event_category: "PRINT",
          event_label: "Liste des frères et sœurs",
          duration: end - start,
        });
      } catch (error) {
        this.$message.error(this.$t("action.erreurImpression"));
      } finally {
        this.loadingSiblingsPdf = false;
      }
    },
    async generatePdf() {
      if (!(await this.packHasBtnAccess("prStudentList"))) return;

      this.$gtag.event("Imp tab listeElèves", {
        event_category: "Impression PDF",
        event_label: "Liste des élèves section",
        value: 1,
      });
      const start = performance.now();

      const doc = pdfHeader(this.settings, {
        title: this.$t("liste.listeEleves"),
        locale: this.$i18n.locale
      });
      var arr = [];
      const array = [];
      const isArabic = this.$i18n.locale === 'ar-AR';
      const reverseIfArabic = (arr) => (isArabic ? arr.slice().reverse() : arr);

      for (let i = 0; i < this.filtredTable.length; i++) {
        const identifier = isKenyanSchool()
          ? (this.filtredTable[i].nemisNumber || "--")
          : (this.filtredTable[i].uniqueId || "--");
        arr.push(identifier);

        arr.push(this.filtredTable[i].firstName);
        arr.push(this.filtredTable[i].middleName ? this.filtredTable[i].middleName : "--");
        arr.push(this.filtredTable[i].lastName);
        arr.push(this.filtredTable[i].scolarite);
        arr.push(this.filtredTable[i].adress);

        // Reverse the array if Arabic language
        if (isArabic) {
          arr.reverse();
        }

        array.push(arr);
        arr = [];
      }

      // Prepare headers
      const headers = reverseIfArabic([
        isKenyanSchool() ? this.$t("profil.nemisNumber") : this.$t("liste.identifiantUnique"),
        this.$t("liste.prenom"),
        this.$t("profil.middleName"),
        this.$t("liste.nom"),
        this.$t("liste.scolarite"),
        this.$t("liste.adresse"),
      ]);

      doc.autoTable({
        theme: "grid",
        styles: {
          font: "Amiri",
          halign: isArabic ? "right" : "left"
        },
        startY: 45,
        head: [headers],
        body: array,
        foot: [
          reverseIfArabic([
            {
              colSpan: 4,
              content: this.$t("liste.total"),
              styles: { halign: "center" },
            },
            {
              colSpan: 2,
              content: this.filtredTable.length,
              styles: { halign: "center" },
            },
          ]),
        ],
      });
      //page numbering
      const pages = doc.internal.getNumberOfPages();
      const pageWidth = doc.internal.pageSize.width;
      const pageHeight = doc.internal.pageSize.height;
      doc.setFontSize(8); //Optional

      for (let j = 1; j < pages + 1; j++) {
        let horizontalPos = pageWidth / 2;
        let verticalPos = pageHeight - 10;
        doc.setPage(j);
        doc.text(
          this.$t("pdf.pageNumber", { current: j, total: pages }),
          horizontalPos,
          verticalPos,
          {
            align: "center",
          }
        );
      }
      //end page numbering
      doc.save(this.$t("liste.listeEleves") + ".pdf");
      const end = performance.now();
      this.$gtag.event("Imp tab listeElèves", {
        event_category: "PRINT",
        event_label: "Liste des élèves section",
        duration: end - start,
      });
    },
    async attestationInscriptionPDF(record) {
      this.loadingData = true;
      const start = performance.now();

      // Get stamp from schoolDetails
      let stamp = "";
      if (this.schoolDetails && this.schoolDetails.stamp) {
        stamp = this.settings.resourcesUrl.replace(
          "FILE_PATH",
          this.schoolDetails.stamp
        );
      }

      const stampImage = new Image();
      if (stamp) stampImage.src = stamp;

      const doc = pdfHeader(this.settings, {
        locale: this.$i18n.locale,
        logoSize: 30,
      });

      const pdfWidth = doc.internal.pageSize.getWidth();

      if (record) {
        const titre = this.$t("attestationInscription.title");

        const isKenyan = this.isKenyanSchool();
        const directeurWord = isKenyan
          ? this.$t("etablissement.headMaster")
          : (this.schoolDetails?.headMasterGender === "female"
            ? this.$t("attestationInscription.directorFemale")
            : this.$t("attestationInscription.directorMale"));

        const isRTL = this.$i18n.locale === "ar-AR";

        // Use default fields (Arabic) for Arabic locale, French fields for others
        const headMasterName = isRTL
          ? (this.schoolDetails?.headMaster || this.activeBuilding.headMaster)
          : (this.schoolDetails?.headMasterFrench || this.activeBuilding.headMaster);

        const studentName = isRTL
          ? (record.firstName + (record.middleName ? " " + record.middleName : "") + " " + record.lastName)
          : ((record.firstNameFr || record.firstName) + (record.middleNameFr || record.middleName ? " " + (record.middleNameFr || record.middleName) : "") + " " + (record.lastNameFr || record.lastName));

        doc.setFontSize(25);
        const titleWidth = doc.getTextWidth(titre);
        const pageWidth = doc.internal.pageSize.getWidth();
        const titleX = (pageWidth - titleWidth) / 2;
        doc.text(titleX, 70, titre, { rtl: isRTL });

        doc.setFontSize(15);

        // Create text parts with mixed formatting (bold for names)
        const className = record.classRoom || "";
        const schoolType = getSchoolTypeLabel(this.schoolDetails || this.activeBuilding);

        // Render text with automatic line wrapping
        const textLeftMargin = 20;
        const textRightMargin = pdfWidth - 20;
        const maxWidth = pdfWidth - 40;
        const lineHeight = 11;
        let yPosition = 90;

        // Build text parts with bold formatting
        const textParts = isRTL ? [
          { text: this.$t("attestationInscription.iUndersigned") + " ", bold: false },
          { text: headMasterName + " ", bold: true },
          { text: directeurWord + " ", bold: false },
          { text: this.$t("attestationInscription.ofThe") + " ", bold: false },
          { text: schoolType + " ", bold: false },
          { text: this.activeBuilding.name + " ", bold: false },
          { text: this.$t("attestationInscription.certifiesThatStudent") + " ", bold: false },
          { text: studentName + " ", bold: true },
          { text: this.$t("attestationInscription.bornOn") + " ", bold: false },
          { text: record.BirthDate + " ", bold: false },
          { text: this.$t("attestationInscription.isEnrolledIn") + " ", bold: false },
          { text: this.currentYearFormatted, bold: false },
          { text: className ? ` ${this.$t("attestationInscription.inClass")} ${className}.` : ".", bold: false }
        ] : [
          { text: this.$t("attestationInscription.iUndersigned") + " ", bold: false },
          { text: headMasterName, bold: true },
          { text: ` ${directeurWord} ${this.$t("attestationInscription.ofThe")} ${schoolType.toLowerCase()} ${this.activeBuilding.name} ${this.$t("attestationInscription.certifiesThatStudent")} `, bold: false },
          { text: studentName, bold: true },
          { text: ` ${this.$t("attestationInscription.bornOn")} ${record.BirthDate} ${this.$t("attestationInscription.isEnrolledIn")} ${this.currentYearFormatted}`, bold: false },
          { text: className ? ` ${this.$t("attestationInscription.inClass")} ${className}.` : ".", bold: false }
        ];

        // Render text parts with word wrapping
        let xPosition = isRTL ? textRightMargin : textLeftMargin;
        let currentY = yPosition;

        textParts.forEach((part, partIndex) => {
          doc.setFont(undefined, part.bold ? 'Bold' : 'normal');
          const words = part.text.split(' ').filter(w => w.length > 0);

          words.forEach((word, wordIndex) => {
            // Add space after each word except the last word of the last part
            const isLastWordOfLastPart = (partIndex === textParts.length - 1) && (wordIndex === words.length - 1);
            const wordWithSpace = isLastWordOfLastPart ? word : word + ' ';
            const wordWidth = doc.getTextWidth(wordWithSpace);

            if (isRTL) {
              // RTL: Check if word fits on current line (moving left)
              if (xPosition - wordWidth < textLeftMargin) {
                currentY += lineHeight;
                xPosition = textRightMargin;
              }
              xPosition -= wordWidth;
              doc.text(wordWithSpace, xPosition, currentY);
            } else {
              // LTR: Check if word fits on current line (moving right)
              if (xPosition + wordWidth > textLeftMargin + maxWidth && xPosition > textLeftMargin) {
                xPosition = textLeftMargin;
                currentY += lineHeight;
              }
              doc.text(wordWithSpace, xPosition, currentY);
              xPosition += wordWidth;
            }
          });
        });

        // Add footer with recuEn and date
        doc.setFontSize(12);
        const footerDate = new Date().toLocaleDateString("fr-FR", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        });

        const signedIn = `${this.$t("attestationInscription.doneAt")} ${this.recuEnInscription || "...................."}, ${this.$t("attestationInscription.on")} ${footerDate}`;
        const signatureText = this.$t("attestationInscription.signatureAndStamp");
        const headmasterSignature = isKenyan
          ? this.$t("etablissement.headMaster")
          : (this.schoolDetails?.headMasterGender === "female"
            ? this.$t("attestationInscription.directorFemale")
            : this.$t("attestationInscription.directorMale"));
        doc.setFontSize(15);
        const footerRightMargin = pdfWidth - 20;
        const footerLeftMargin = 20;

        // Footer positions adjusted to maintain spacing with content moved down
        const signedInWidth = doc.getTextWidth(signedIn);
        const signedInX = isRTL ? footerLeftMargin : footerRightMargin;
        const signedInAlign = isRTL ? "left" : "right";
        const signatureX = isRTL
          ? footerLeftMargin + signedInWidth / 2
          : footerRightMargin - signedInWidth / 2;
        const textOptions = isRTL ? { align: "center", rtl: true } : { align: "center" };

        doc.text(signedIn, signedInX, 150, { align: signedInAlign, rtl: isRTL });
        doc.text(signatureText, signatureX, 160, textOptions);
        doc.text(headmasterSignature, signatureX, 170, textOptions);

        // Add stamp if enabled
        if (stamp && this.showStampInscription) {
          try {
            await this.waitLoadingImage(stampImage);
            const stampSize = 40;
            // Center stamp on signature text (signatureX is already the center point)
            const stampX = signatureX - stampSize / 2;
            doc.addImage(stampImage, "JPEG", stampX, 180, stampSize, stampSize);
          } catch (e) {}
        }
      }
      doc.save(this.$t("liste.attestationInscription") + ".pdf");
      const end = performance.now();
      this.loadingData = false;
      this.visibleAttestationInscription = false;
      this.showStampInscription = true;
      this.recuEnInscription = "";
      this.$gtag.event("Imp attestation d'inscription", {
        event_category: "PRINT",
        event_label: "Liste des élèves section",
        duration: end - start,
      });
    },
    //arabe
    async attestationPresencePDF() {
      this.loadingData = true;
      this.visibleAttestationPresence = false;

      const pdfData = {
        commissariat: $("#cr").val(),
        nomStudent: $("#nomStudent").val(),
        uniqueId: $("#uniqueIdStudent").val(),
        BirthDate: moment(this.attestationPresenceBirthdate).format(
          "YYYY/MM/DD"
        ),
        className: $("#className").val(),
        reason: $("#reason").val(),
        recuEn: $("#recuEn").val(),
        headMaster: $("#dir").val(),
      };

      let stamp = "";
      await apiClient
        .get("/buildings/" + this.settings.activeBuildingId + "/stamp")
        .then((res) => {
          if (res.data.imageURL) {
            stamp = this.settings.resourcesUrl.replace(
              "FILE_PATH",
              res.data.imageURL
            );
          }
        })
        .catch((e) => {
          console.log(e);
        });

      const stampImage = new Image();
      if (stamp) stampImage.src = stamp;

      let arrayOfImages = this.settings.image;
      let imgData;
      for (var i = 0; i < arrayOfImages.length; i++) {
        if (this.settings.activeBuilding === arrayOfImages[i].db) {
          imgData = new Image();
          imgData.src = arrayOfImages[i].logo;
          break;
        }
      }
      const generateArcEnCielPDF = async () => {
        const doc = new JsPDF();
        const pdfWidth = doc.internal.pageSize.getWidth();
        const pdfHeight = doc.internal.pageSize.getHeight();
        doc.setFont("Amiri");

        doc.setDrawColor(135, 206, 235);
        doc.setLineWidth(2);
        doc.setLineDashPattern([5, 3], 0);
        doc.rect(10, 10, pdfWidth - 20, pdfHeight - 20);

        let date = new Date();

        const t1 = "الجمهورية التونسية";
        const t2 = "وزارة التربية";
        const t3 = "المندوبية الجهوية بسليانة";
        const t4 = pdfData.commissariat;
        const t5 = getSchoolTypeLabel(this.schoolDetails, 'ar-AR');
        let width = doc.getTextWidth(t1);
        let nwidth = 0;
        doc.text(t1, pdfWidth - 60 + (25 - width / 2), 25);
        width = doc.getTextWidth(t2);
        doc.text(t2, pdfWidth - 60 + (25 - width / 2), 35);
        width = doc.getTextWidth(t3);
        doc.text(t3, pdfWidth - 60 + (25 - width / 2), 45);
        width = doc.getTextWidth(t4);
        doc.text(t4, pdfWidth - 60 + (25 - width / 2), 55);
        width = doc.getTextWidth(t5);
        doc.text(t5, 80 - (40 + width / 2), 25);
        width = doc.getTextWidth(this.schoolDetails.ArabicName);
        doc.text(this.schoolDetails.ArabicName, 80 - (45 + width / 2), 35);
        const flagImage = new Image();
        flagImage.src = "/resources/images/flag.jpg";

        const govImage = new Image();
        govImage.src = "/resources/images/gov.jpg";
        if (imgData) {
          doc.addImage(imgData, "JPEG", 68, 20, 18, 18);
          doc.addImage(flagImage, "JPEG", 100, 20, 18, 18);
          doc.addImage(govImage, "JPEG", 130, 20, 18, 18);
        }

        doc.setFontSize(12);
        const titre = "شهادة حضور";
        const schoolTypeAr = getSchoolTypeLabel(this.schoolDetails, 'ar-AR');
        const school = ` : يشهد مدير ${schoolTypeAr} ${this.schoolDetails?.ArabicName || ''}`;
        const student = " : (أن التلميذ )ة";
        const birth = pdfData.BirthDate + " : المولود )ة( في";
        const inscriIn = `(مرسّم )ة( ب${schoolTypeAr} ${this.schoolDetails?.ArabicName || ''} و يزاول دراسته )ها`;
        const inscriIn2 = `ب`;
        const reasonTitle = ": سلّمت هذه الشهادة للمعني بالأمر )ة( قصد";
        const reason = pdfData.reason;

        date = new Date().toISOString().split("T")[0].replace(/\-/g, "/");
        const signedIn = `${date} : حرّر بسليانة في `;

        const signature = "الإمضاء و الختم";
        const headmasterSignature = "(المدير )ة";
        const headmasterName = pdfData.headMaster;

        doc.setFontSize(30);
        width = doc.getTextWidth(titre);
        doc.text(titre, pdfWidth / 2 - width / 2, 90);
        doc.setFontSize(15);

        width = doc.getTextWidth(school);
        doc.text(school, pdfWidth - width - 20, 110);

        nwidth = doc.getTextWidth(pdfData.headMaster);
        doc.text(pdfData.headMaster, pdfWidth - width - nwidth - 20, 110);

        width = doc.getTextWidth(student);
        doc.text(student, pdfWidth - width - 20, 110 + 10);

        nwidth = doc.getTextWidth(pdfData.nomStudent);
        doc.text(pdfData.nomStudent, pdfWidth - width - nwidth - 20, 110 + 10);

        width = doc.getTextWidth(birth);
        doc.text(birth, pdfWidth - width - 20, 110 + 20);

        width = doc.getTextWidth(inscriIn);
        doc.text(inscriIn, pdfWidth - width - 20, 110 + 30);
        width = doc.getTextWidth(inscriIn2);
        doc.text(inscriIn2, pdfWidth - width - 20, 110 + 40);

        nwidth = doc.getTextWidth(pdfData.className);
        doc.text(pdfData.className, pdfWidth - width - nwidth - 20, 110 + 40);

        width = doc.getTextWidth(reasonTitle);
        doc.text(reasonTitle, pdfWidth - width - 20, 110 + 50);
        doc.setFontSize(13);
        width = doc.getTextWidth(reason);
        doc.text(reason, pdfWidth - width - 26, 110 + 60);
        doc.setFontSize(15);
        width = doc.getTextWidth(signedIn);
        doc.text(signedIn, pdfWidth - width - 90, 200);

        width = doc.getTextWidth(signature);
        doc.text(signature, pdfWidth - width - 40, 210);

        width = doc.getTextWidth(headmasterSignature);
        doc.text(headmasterSignature, pdfWidth - width - 40, 220);

        width = doc.getTextWidth(headmasterName);
        doc.text(headmasterName, pdfWidth - width - 40, 230);

        if (this.showStamp && stamp) {
          try {
            await new Promise((resolve, reject) => {
              if (stampImage.complete) {
                resolve();
              } else {
                stampImage.onload = resolve;
                stampImage.onerror = reject;
              }
            });

            doc.addImage(stampImage, "JPEG", pdfWidth / 2 + 25, 230, 40, 40);
          } catch (error) {
            console.error("Stamp image failed to load, skipping stamp.", error);
          }
        }

        doc.save(`attestation_présence.pdf`);
      };
      const generateDefaultPDF = async () => {
        let serialNumber;
        try {
          const response = await apiClient.post("/printNumber", {
            type: "attPres",
            student: this.activeStudent._id,
          });
          serialNumber = response.data.serialNumber;
        } catch (error) {
          console.error("Error fetching serial number:", error);
        }
        const doc = new JsPDF("l", "mm", "a4");
        const pdfWidth = doc.internal.pageSize.getWidth();
        const pdfHeight = doc.internal.pageSize.getHeight();

        const drawMixedText = (
          x,
          y,
          text,
          baseFontSize,
          targetRegex,
          smallReduction
        ) => {
          let parts = [];
          let lastIndex = 0;
          let regex = new RegExp(targetRegex, "g");
          let match;
          while ((match = regex.exec(text)) !== null) {
            if (match.index > lastIndex) {
              parts.push({
                text: text.slice(lastIndex, match.index),
                small: false,
              });
            }
            parts.push({ text: match[0], small: true });
            lastIndex = match.index + match[0].length;
          }
          if (lastIndex < text.length) {
            parts.push({ text: text.slice(lastIndex), small: false });
          }

          let currentX = x;
          parts.forEach((part) => {
            if (part.small) {
              doc.setFontSize(baseFontSize - smallReduction);
            } else {
              doc.setFontSize(baseFontSize);
            }
            doc.text(part.text, currentX, y);
            currentX += doc.getTextWidth(part.text);
          });
          doc.setFontSize(baseFontSize);
        };

        const getMixedTextWidth = (
          text,
          baseFontSize,
          targetRegex,
          smallReduction
        ) => {
          let totalWidth = 0;
          let lastIndex = 0;
          let regex = new RegExp(targetRegex, "g");
          let match;
          while ((match = regex.exec(text)) !== null) {
            if (match.index > lastIndex) {
              doc.setFontSize(baseFontSize);
              totalWidth += doc.getTextWidth(
                text.slice(lastIndex, match.index)
              );
            }
            doc.setFontSize(baseFontSize - smallReduction);
            totalWidth += doc.getTextWidth(match[0]);
            lastIndex = match.index + match[0].length;
          }
          if (lastIndex < text.length) {
            doc.setFontSize(baseFontSize);
            totalWidth += doc.getTextWidth(text.slice(lastIndex));
          }
          return totalWidth;
        };

        // Make the helper async so we can await stamp image loading
        const createDocumentHalf = async (xOffset, isRightHalf = false) => {
          doc.setFont("Amiri");
          let date = new Date();
          const halfWidth = pdfWidth / 2;
          const scaleFactor = 0.8;
          const imgWidth = 15 * scaleFactor;
          const imgHeight = 20 * scaleFactor;
          const imgMargin = 1;
          const imgX = isRightHalf
            ? halfWidth - imgWidth - imgMargin
            : pdfWidth - imgWidth - imgMargin;
          const image = new Image();
          image.src = "/resources/images/print.png";
          const govImage = new Image();
          govImage.src = "/resources/images/gov.jpg";
          doc.addImage(
            image,
            "PNG",
            imgX,
            pdfHeight / 2 - imgHeight / 2,
            imgWidth,
            imgHeight
          );

          const contentMargin = imgWidth + imgMargin + 5;
          const textAlignRight = isRightHalf
            ? pdfWidth - contentMargin
            : halfWidth - contentMargin;
          const headerTexts = [
            "الجمهورية التونسية",
            "وزارة التربية",
            "المندوبية الجهوية للتربية",
            pdfData.commissariat,
          ];
          const xor = (a, b) => a !== b;
          const topTextFontSize = xor(this.showSchoolLogo, this.showGovLogo)
            ? 12
            : !this.showSchoolLogo && !this.showGovLogo
            ? 14
            : 8;
          doc.setFontSize(topTextFontSize);
          headerTexts.forEach((text, index) => {
            doc.text(
              text,
              textAlignRight - doc.getTextWidth(text),
              index *
                (xor(this.showSchoolLogo, this.showGovLogo)
                  ? 6
                  : !this.showSchoolLogo && !this.showGovLogo
                  ? 7
                  : 5) +
                6
            );
          });

          if (imgData && this.showSchoolLogo) {
            try {
              await new Promise((resolve, reject) => {
                if (imgData.complete) {
                  resolve();
                } else {
                  imgData.onload = resolve;
                  imgData.onerror = reject;
                }
              });
              const imgMargin = 4;
              const imgX = isRightHalf ? halfWidth + imgMargin : imgMargin;
              doc.addImage(imgData, "JPEG", imgX, 2, 25, 25);
            } catch (e) {
              this.showSchoolLogo = false;
            }
          }
          const govImgWidth = 25;
          let govImgX = isRightHalf
            ? pdfWidth / 2 + (pdfWidth / 2 - govImgWidth) / 2 - 7
            : (pdfWidth / 2 - govImgWidth) / 2 - 7;
          if (this.showGovLogo) {
            if (!this.showSchoolLogo)
              govImgX = isRightHalf ? halfWidth + imgMargin : imgMargin;
            doc.addImage(govImage, "JPEG", govImgX, 2, govImgWidth, 22);
          }
          const centerX = isRightHalf
            ? pdfWidth - halfWidth / 2
            : halfWidth / 2;
          doc.setFontSize(18);
          const titre = "شهادة حضور";
          const titleWidth = doc.getTextWidth(titre);
          const titleX = centerX - titleWidth / 2;
          doc.text(titre, titleX, 65);
          doc.setTextColor(255, 0, 0);
          doc.setFontSize(10);
          const serialText = `N° ${serialNumber}`;
          const serialX = titleX - doc.getTextWidth(serialText) - 5;
          doc.text(serialText, serialX, 65);
          doc.setTextColor(0, 0, 0);
          doc.setFontSize(10);

          const schoolTypeAr = getSchoolTypeLabel(this.schoolDetails, 'ar-AR');
          const detailsMap = [
            {
              parts: [
                { text: ` ${schoolTypeAr}`, small: false },
                { text: "(1)", small: true, reduction: 3 },
                { text: " : ", small: false },
                { text: "يشهد مدير", small: false },
              ].reverse(),
              value: this.schoolDetails.ArabicName,
            },
            { label: " : (أن التلميذ )ة", value: pdfData.nomStudent },
            { label: " : المولود )ة( في", value: pdfData.BirthDate },
            {
              label: `مرسّم )ة( بالمدرسة */ المعهد المذكور )ة(* أعلاه تحت  المعرف الوحيد  ${pdfData.uniqueId}`,
              value: "",
            },
            {
              parts: [
                { text: pdfData.className, small: false },
                { text: " (2)", small: true, reduction: 3 },
                { text: "ب", small: false },
                { text: " (ها)", small: false },
                { text: " و يزاول دراسته", small: false },
              ].reverse(),
              value: "",
            },
          ];

          const baseFontSizeLabels = 10;
          detailsMap.forEach((detail, index) => {
            const yPosition = 80 + index * 7;

            if (detail.parts) {
              let totalWidth = 0;
              detail.parts.forEach((part) => {
                doc.setFontSize(
                  part.small
                    ? baseFontSizeLabels - (part.reduction || 2)
                    : baseFontSizeLabels
                );
                totalWidth += doc.getTextWidth(part.text);
              });

              let currentX = textAlignRight;
              detail.parts.forEach((part) => {
                doc.setFontSize(
                  part.small
                    ? baseFontSizeLabels - (part.reduction || 2)
                    : baseFontSizeLabels
                );
                currentX -= doc.getTextWidth(part.text);
                doc.text(part.text, currentX, yPosition);
              });

              if (detail.value) {
                doc.setFontSize(baseFontSizeLabels);
                doc.text(
                  detail.value,
                  textAlignRight -
                    totalWidth -
                    doc.getTextWidth(detail.value) -
                    2,
                  yPosition
                );
              }
            } else {
              const totalWidth = getMixedTextWidth(
                detail.label,
                baseFontSizeLabels,
                "\\([12]\\)",
                2
              );
              const labelX = textAlignRight - totalWidth;
              drawMixedText(
                labelX,
                yPosition,
                detail.label,
                baseFontSizeLabels,
                "\\([12]\\)",
                3
              );
              if (detail.value) {
                const labelPartWidth = getMixedTextWidth(
                  detail.label,
                  baseFontSizeLabels,
                  "\\([12]\\)",
                  3
                );
                doc.text(
                  detail.value,
                  textAlignRight -
                    labelPartWidth -
                    doc.getTextWidth(detail.value) -
                    2,
                  yPosition
                );
              }
            }
          });

          doc.setFontSize(10);
          const reasonTitle = ": سلّمت هذه الشهادة للمعني بالأمر )ة( قصد";
          doc.text(
            reasonTitle,
            textAlignRight - doc.getTextWidth(reasonTitle),
            118
          );
          doc.setFontSize(9);
          doc.text(
            pdfData.reason,
            textAlignRight - doc.getTextWidth(pdfData.reason) - 2,
            124
          );
          date = new Date().toISOString().split("T")[0].replace(/\-/g, "/");
          const signedIn = `${date} حرّر بـ ${pdfData.recuEn} في`;
          const signatureDetails = [
            signedIn,
            "الإمضاء و الختم",
            "(3) (المدير )ة",
            pdfData.headMaster,
          ];
          doc.setFontSize(9);
          const signatureX = isRightHalf ? pdfWidth - halfWidth + 40 : 40;
          signatureDetails.forEach((text, index) => {
            if (index === 2) {
              const totalWidth = getMixedTextWidth(text, 9, "\\(3\\)", 3);
              const startX = signatureX - totalWidth / 2;
              drawMixedText(startX, 145 + index * 6, text, 9, "\\(3\\)", 3);
            } else {
              doc.text(
                text,
                signatureX - doc.getTextWidth(text) / 2,
                145 + index * 6
              );
            }
          });
          doc.setFontSize(7);
          const indications = [
            { number: "", text: "____________________" },
            { number: "(1)", text: "بيان إسم المؤسسة التربوية" },
            { number: "(2)", text: "يذكر الفصل بلسان القلم" },
            { number: "(3)", text: "يذكر الإسم و اللقب و الصفة" },
            { number: "(*)", text: "يشطب الزائد" },
          ];
          doc.setFontSize(7);
          indications.forEach((indication, index) => {
            const textPosition = textAlignRight - 40;
            const numberPosition =
              textPosition + doc.getTextWidth(indication.text);
            doc.text(indication.text, textPosition, 170 + index * 4);
            doc.text(indication.number, numberPosition, 170 + index * 4);
          });

          if (stamp && this.showStamp) {
            try {
              await new Promise((resolve, reject) => {
                if (stampImage.complete) {
                  resolve();
                } else {
                  stampImage.onload = resolve;
                  stampImage.onerror = reject;
                }
              });
              const stampX = isRightHalf ? pdfWidth - halfWidth + 28 : 28;
              doc.addImage(stampImage, "JPEG", stampX, 165, 25, 25);
            } catch (error) {
              console.error(
                "Stamp image failed to load, skipping stamp.",
                error
              );
            }
          }
        };

        await createDocumentHalf(0, false);
        await createDocumentHalf(0, true);
        doc.save("attestation_présence.pdf");
      };

      try {
        if (this.schoolAccessTemplateID === "AC") {
          await generateArcEnCielPDF();
        } else {
          await generateDefaultPDF();
        }
      } catch (error) {
        console.error("Error generating PDFs:", error);
      } finally {
        this.loadingData = false;
      }
    },
    async attestationPresenceFr(record) {
      const start = performance.now();
      this.loadingData = true;

      this.visibleAttestationPresence = false;
      const student = record || this.activeStudent || {};
      // Prefer French name fields; if empty/blank, fall back to default names
      const resolveNamePart = (frenchValue, defaultValue) => {
        const french = (frenchValue || "").toString().trim();
        const fallback = (defaultValue || "").toString().trim();
        return french || fallback;
      };
      const firstName = resolveNamePart(student.firstNameFr, student.firstName);
      const middleName = resolveNamePart(
        student.middleNameFr,
        student.middleName
      );
      const lastName = resolveNamePart(student.lastNameFr, student.lastName);
      const frenchStudentName = [firstName, middleName, lastName]
        .filter(Boolean)
        .join(" ");
      const frenchHeadMaster =
        (this.schoolDetails?.headMasterFrench || "").toString().trim() ||
        (this.schoolDetails?.headMaster || "").toString().trim() ||
        (this.activeBuilding?.headMaster || "").toString().trim() ||
        ($("#dir").val() || "").toString().trim();
      const pdfData = {
        commissariat: $("#cr").val(),
        nomStudent:
          frenchStudentName ||
          ($("#nomStudent").val() || "").toString().trim(),
        uniqueId: $("#uniqueIdStudent").val(),
        BirthDate: moment(this.attestationPresenceBirthdate).format(
          "DD/MM/YYYY"
        ),
        className: $("#className").val(),
        reason: $("#reason").val(),
        recuEn: $("#recuEn").val(),
        headMaster: frenchHeadMaster,
      };

      let stamp = "";
      await apiClient
        .get("/buildings/" + this.settings.activeBuildingId + "/stamp")
        .then((res) => {
          if (res.data.imageURL) {
            stamp = this.settings.resourcesUrl.replace(
              "FILE_PATH",
              res.data.imageURL
            );
          }
        })
        .catch((e) => {
          console.log(e);
        });
      const stampImage = new Image();
      if (stamp) stampImage.src = stamp;

      let arrayOfImages = this.settings.image;
      let imgData;
      for (var i = 0; i < arrayOfImages.length; i++) {
        if (this.settings.activeBuilding === arrayOfImages[i].db) {
          imgData = new Image();
          imgData.src = arrayOfImages[i].logo;
          break;
        }
      }

      const doc = new JsPDF();
      const pdfWidth = doc.internal.pageSize.getWidth();
      doc.setFont("Amiri");
      var date = new Date();

      const t1 = "République Tunisienne";
      const t2 = "Ministère de l'Education";
      const t3 = "Commissariat Régional de l'Education";
      const t4 = pdfData.commissariat;
      const t5 = getSchoolTypeLabel(this.schoolDetails || { type: 'ecole', countryCode: 'TN' });

      doc.text(t1, 10, 10, { align: "left" });
      doc.text(t2, 10, 18, { align: "left" });
      doc.text(t3, 10, 26, { align: "left" });
      doc.text(t4, 10, 34, { align: "left" });

      doc.text(t5, pdfWidth - 10, 10, { align: "right" });
      doc.text(this.schoolDetails.name, pdfWidth - 10, 18, { align: "right" });
      const schoolNameWidth = doc.getTextWidth(this.schoolDetails.name);
      try {
        if (imgData) {
          await this.waitLoadingImage(imgData);
          const imageWidth = 22;
          const imageX = pdfWidth - 10 - schoolNameWidth / 2 - imageWidth / 2;
          doc.addImage(imgData, "JPEG", imageX, 25, imageWidth, imageWidth);
        }
      } catch (e) {
        this.showSchoolLogo = false;
      }

      doc.setFontSize(12);
      date = new Date().toLocaleDateString("fr-FR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });

      const signedIn = `Fait à ${pdfData.recuEn}, le ${date}`;
      const signature = "Signature et Cachet";
      const headmasterSignature = this.schoolDetails?.headMasterGender === "female" ? "La Directrice" : "Le Directeur";
      doc.setFontSize(15);
      const rightMargin = pdfWidth - 20;

      if (record) {
        var titre = "Attestation de présence";
        const directeurWord = this.schoolDetails?.headMasterGender === "female" ? "la directrice" : "le directeur";
        const headMasterPrefix = this.schoolDetails?.headMasterGender === "female" ? "Mme." : "M.";
        const className = pdfData.className || record.classRoom || "";
        const headMasterName = pdfData.headMaster;
        const studentName = pdfData.nomStudent;

        doc.setFontSize(30);
        doc.text(titre, 55, 90);
        doc.setFontSize(15);

        // Create text parts with mixed formatting (bold for names)
        const schoolTypeFr = getSchoolTypeLabel(this.schoolDetails, 'fr-FR');
        const textParts = [
          { text: `Je soussigné ${headMasterPrefix} `, bold: false },
          { text: headMasterName, bold: true },
          { text: ` ${directeurWord} du ${schoolTypeFr.toLowerCase()} ${this.schoolDetails.name} atteste que l'élève `, bold: false },
          { text: studentName, bold: true },
          { text: pdfData.uniqueId ? ` d'identifiant unique ${pdfData.uniqueId} ` : " ", bold: false },
          { text: `né(e) le ${pdfData.BirthDate} est présent(e) au sein de notre établissement pour l'année scolaire ${this.currentYearFormatted}`, bold: false },
          { text: className ? ` en classe ${className}.` : ".", bold: false }
        ];

        let xPosition = 20;
        let yPosition = 110;
        const maxWidth = pdfWidth - 40;
        const lineHeight = 11;

        textParts.forEach(part => {
          doc.setFont(undefined, part.bold ? 'Bold' : 'normal');
          const words = part.text.split(' ');

          words.forEach((word, index) => {
            const wordWithSpace = index < words.length - 1 ? word + ' ' : word;
            const wordWidth = doc.getTextWidth(wordWithSpace);

            // Check if word fits on current line
            if (xPosition + wordWidth > 20 + maxWidth && xPosition > 20) {
              xPosition = 20;
              yPosition += lineHeight;
            }

            doc.text(wordWithSpace, xPosition, yPosition);
            xPosition += wordWidth;
          });
        });

        doc.text(signedIn, rightMargin, 165, { align: "right" });
        const signedInWidth = doc.getTextWidth(signedIn);
        const signatureX = rightMargin - signedInWidth / 2;
        doc.text(signature, signatureX, 175, { align: "center" });
        doc.text(headmasterSignature, signatureX, 185, { align: "center" });
      }
      if (stamp && this.showStamp) {
        try {
          await this.waitLoadingImage(stampImage);
          const signedInWidth = doc.getTextWidth(signedIn);
          const signatureX = rightMargin - signedInWidth / 2;
          const stampX = signatureX - 20;
          doc.addImage(stampImage, "JPEG", stampX, 195, 40, 40);
        } catch (e) {}
      }

      this.loadingData = false;
      doc.save("attestation_présence.pdf");
      const end = performance.now();
      this.$gtag.event("Imp fr attestation de présence", {
        event_category: "PRINT",
        event_label: "Liste des élèves section",
        duration: end - start,
      });
    },
    waitLoadingImage(image) {
      return new Promise((res, rej) => {
        // If image is already loaded, resolve immediately
        if (image.complete && image.naturalWidth > 0) {
          res();
          return;
        }

        // Otherwise, wait for load or error event
        image.onload = (t) => {
          res();
        };
        image.onerror = (e) => {
          rej();
        };
      });
    },

    attestationReussitePDF(record) {
      let arrayOfImages = this.settings.image;
      for (var i = 0; i < arrayOfImages.length; i++) {
        if (this.settings.activeBuilding === arrayOfImages[i].db) {
          var imgData = new Image();
          imgData.src = arrayOfImages[i].logo;
        }
      }
      const doc = new JsPDF();
      doc.setFont("Amiri");
      var date = new Date();
      var titre = "Attestation de réussite";
      const options = {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      };
      doc.setFontSize(30);
      doc.text(titre, 55, 90);
      doc.setFontSize(10);
      doc.addImage(imgData, "JPEG", 8, 8, 40, 40);
      doc.setFontSize(12);
      doc.text(150, 40, date.toLocaleDateString("fr-FR", options));
      if (record) {
        var titre = "Attestation de réussite";
        var string = `Je soussigné ${
          this.activeBuilding.headMaster
        } le directeur de l'école ${
          this.activeBuilding.dbName
        }  \n \n atteste que l'élève ${
          record.firstName + " " + record.lastName
        } né(e) le ${
          record.BirthDate
        } est présent(e) \n \n au sein de notre etablissement pour l'année scolaire ${
          this.currentYear
        }.`;
        var signature = "Signature";
        doc.setFontSize(30);
        doc.text(titre, 55, 90);
        doc.setFontSize(15);
        doc.text(string, 20, 110);
        doc.setFontSize(15);
        doc.text(signature, 150, 165);
      }
      doc.save("attestation_réussite.pdf");
    },
    async showModal() {
      this.visibleData = true;
      this.newStudentForm.resetFields();
    },
    onChange(e) {
      this.newStudent.gender = e.target.value;
    },
    onChangeParent(e) {},
    openNotificationWithIcon(type, msg, desc) {
      notification[type]({
        message: msg,
        description: desc,
      });
    },
    handleParentsSuggestions(val) {
      if (this.suggestionTimeout) clearTimeout(this.suggestionTimeout);

      let parentsList = [];

      if (val.target.value) {
        parentsList = this.parentsList.filter(
          (e) =>
            e.fatherPhone == val.target.value ||
            e.motherPhone == val.target.value
        );
      }

      if (parentsList.length > 0) {
        this.suggestionTimeout = setTimeout(() => {
          this.suggestionParentList = parentsList;
          this.selectedSuggestionParent = this.suggestionParentList[0];
          this.visibleParentSuggestion = true;
        }, 700);
      } else {
        this.visibleParentSuggestion = false;
      }
    },
    handleAddParentSuggestion() {
      this.newStudentForm.setFieldsValue({
        parent: this.selectedSuggestionParent.id,
      });
      this.visibleParentSuggestion = false;
      clearTimeout(this.suggestionTimeout);
      setTimeout(() => {
        this.disabledSP = !this.disabledSP;
        this.newParent = !this.newParent;
      }, 100);
    },
    reload(data) {
      this.$emit("reload");
    },
    goToNewPayment() {
      // Navigate directly to the new payment page
      this.$router.push({ path: "/new-payment" });
    },
    confirmGenerateLogins() {
      const levels = this.printSelectionMode === "level" ? this.selectedLevels : null;
      const classes = this.printSelectionMode === "class" ? this.selectedClasses : null;

      if (this.currentLoginType === "student") {
        this.generateStudentLogins(levels, classes);
      } else {
        this.generateLoginsParents(levels, classes);
      }
      this.visibleLevelsSelection = false;
    },
  },
};
</script>
<style scoped>
.fiche-personnel-form {
  width: 100%;
}

.form-row {
  display: flex;
  gap: 12px;
  margin-bottom: 12px;
  width: 100%;
}

.form-item {
  flex: 1;
  min-width: 0;
}

.form-item label {
  display: block;
  width: 100%;
}

.form-item .ant-input,
.form-item .ant-calendar-picker {
  width: 100%;
}

.ant-input,
.ant-calendar-picker {
  max-width: 100%;
}

.highlight {
  background-color: rgb(255, 192, 105);
  padding: 0px;
}

.editable-row-operations a {
  margin-right: 8px;
}

.switch {
  float: right;
  margin-right: 15px;
}

.bottom {
  margin-top: 7px;
}

label {
  width: 300px;
  line-height: 26px;
  margin-bottom: 20px;
}

a-input {
  height: 25px;
  width: 50%;
  margin-left: 50px;
}

.span {
  /* display: flex;  */
  flex-direction: row;
}

.space {
  margin-left: 200px;
}

.inp {
  margin-left: 0px;
}

.clearfix {
  float: right;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}

.border-with-text {
  position: relative;
  border: 2px solid #95a3b3;
  padding: 1rem;
}

.border-with-text .border-text {
  position: absolute;
  top: -12px;
  left: 20px;
  background-color: white;
  padding: 0 10px;
  font-weight: bold;
}

::v-deep .ant-list-item {
  margin-bottom: 0px !important;
}

.custom-border {
  border: 1px solid #6c757d;
  border-radius: 0.25rem;
  cursor: pointer;
}

.custom-border-active {
  border: 3px solid #22bb33;
  border-radius: 0.25rem;
  cursor: pointer;
}
</style>
